(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9586],{

/***/ 169586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ auth_AccountForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(382526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(141817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(932165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(491038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(682772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(747042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(369070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(530489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(968304);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(241539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(788674);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(974916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(477601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(339714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(978783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(333948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(226699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(968309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(132023);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(646523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/url-polyfill/url-polyfill.js
var url_polyfill = __webpack_require__(538264);
// EXTERNAL MODULE: ./node_modules/url-search-params-polyfill/index.js
var url_search_params_polyfill = __webpack_require__(35449);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/growth/auth/NamelessAccountContext.mjs
function cov_2hi0g6241z() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/growth/auth/NamelessAccountContext.tsx";
    var hash = "13be1be7a30b1174eb5e8d5d3a04de18d705a3dc";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/growth/auth/NamelessAccountContext.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 10,
                    column: 38
                },
                end: {
                    line: 18,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 22,
                    column: 4
                },
                end: {
                    line: 41,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 29,
                    column: 2
                },
                end: {
                    line: 40,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 22,
                        column: 4
                    },
                    end: {
                        line: 22,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 6
                    },
                    end: {
                        line: 41,
                        column: 1
                    }
                },
                line: 28
            }
        },
        branchMap: {},
        s: {
            "0": 0,
            "1": 0,
            "2": 0
        },
        f: {
            "0": 0
        },
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "13be1be7a30b1174eb5e8d5d3a04de18d705a3dc"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2hi0g6241z = function cov_2hi0g6241z() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2hi0g6241z();

var NamelessAccountContext = (cov_2hi0g6241z().s[0]++, /*#__PURE__*/ react.createContext(// Default values for context
{
    shouldRegisterOnEmailSubmit: false,
    onPasswordFormLoad: undefined,
    onAccountUpdate: undefined,
    emailRegistrationError: ""
}));
cov_2hi0g6241z().s[1]++;
var NamelessAccountContextProvider = function NamelessAccountContextProvider(_ref) {
    var shouldRegisterOnEmailSubmit = _ref.shouldRegisterOnEmailSubmit, onPasswordFormLoad = _ref.onPasswordFormLoad, onAccountUpdate = _ref.onAccountUpdate, emailRegistrationError = _ref.emailRegistrationError, children = _ref.children;
    cov_2hi0g6241z().f[0]++;
    cov_2hi0g6241z().s[2]++;
    return /*#__PURE__*/ React.createElement(NamelessAccountContext.Provider, {
        value: {
            shouldRegisterOnEmailSubmit: shouldRegisterOnEmailSubmit,
            onPasswordFormLoad: onPasswordFormLoad,
            onAccountUpdate: onAccountUpdate,
            emailRegistrationError: emailRegistrationError
        }
    }, children);
}; //# sourceMappingURL=NamelessAccountContext.mjs.map

// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/i18n/translationHelper.mjs
var translationHelper = __webpack_require__(968888);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(414293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__(560285);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.to-json.js
var web_url_to_json = __webpack_require__(583753);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__(241637);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/ValidatedTextInput/ValidatedTextInput.js + 1 modules
var ValidatedTextInput = __webpack_require__(497402);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/forms/EmailInput.js





var EmailInput = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /* @__PURE__ */ {
    var analyticsName = _param.analyticsName, _fieldRequiredError = _param.fieldRequiredError, fieldRequiredError = _fieldRequiredError === void 0 ? "This field is required." : _fieldRequiredError, _invalidEmailError = _param.invalidEmailError, invalidEmailError = _invalidEmailError === void 0 ? "Please enter a valid email address." : _invalidEmailError, _disableSuggestions = _param.disableSuggestions, disableSuggestions = _disableSuggestions === void 0 ? !1 : _disableSuggestions, _title = _param.title, title = _title === void 0 ? "Email" : _title, _size = _param.size, size = _size === void 0 ? "medium" : _size, _required = _param.required, required = _required === void 0 ? !0 : _required, ariaLabelledBy = _param.ariaLabelledBy, props = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "fieldRequiredError",
        "invalidEmailError",
        "disableSuggestions",
        "title",
        "size",
        "required",
        "ariaLabelledBy"
    ]);
    return (0,jsx_runtime.jsx)(ValidatedTextInput/* ValidatedTextInput */.O, (0,_object_spread/* default */.Z)({
        ref: ref,
        id: "email-login-input",
        analyticsName: "".concat(analyticsName, "-email"),
        format: "emailAddress",
        size: size,
        required: required,
        allowSuggestions: !disableSuggestions,
        customErrorMessages: {
            fieldRequired: fieldRequiredError,
            invalidEmail: invalidEmailError
        }
    }, ariaLabelledBy ? {
        ariaLabelledBy: ariaLabelledBy
    } : {
        title: title
    }, props));
});
EmailInput.displayName = "EmailInput";


// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(125923);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(422470);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/forms/AccountFormControls.js





var AccountFormControls = function(param) {
    var analyticsName = param.analyticsName, loading = param.loading, _onRequestPasswordlessLogin = param.onRequestPasswordlessLogin, isRequestingPasswordlessLogin = param.isRequestingPasswordlessLogin, disabled = param.disabled, _actionText = param.actionText, actionText = _actionText === void 0 ? "Confirm" : _actionText, _showForgotPassword = param.showForgotPassword, showForgotPassword = _showForgotPassword === void 0 ? !0 : _showForgotPassword, openForgotPasswordInNewTab = param.openForgotPasswordInNewTab, _forgotPasswordText = param.forgotPasswordText, forgotPasswordText = _forgotPasswordText === void 0 ? "Forgot password?" : _forgotPasswordText, _forgotPasswordAriaNewWindow = param.forgotPasswordAriaNewWindow, forgotPasswordAriaNewWindow = _forgotPasswordAriaNewWindow === void 0 ? "Forgot password? Opens in a new window" : _forgotPasswordAriaNewWindow, _forgotPasswordAriaSameWindow = param.forgotPasswordAriaSameWindow, forgotPasswordAriaSameWindow = _forgotPasswordAriaSameWindow === void 0 ? "Forgot password?" : _forgotPasswordAriaSameWindow, submitA11yProps = param.submitA11yProps;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        gap: "$20x",
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
                testID: "account-form-submit-button",
                variant: "primary",
                type: "submit",
                label: actionText,
                size: "medium",
                analyticsName: "".concat(analyticsName, "-account-form-control-action-button"),
                width: "100%",
                loading: loading && !isRequestingPasswordlessLogin,
                disabled: disabled
            }, submitA11yProps)),
            showForgotPassword && /* @__PURE__ */ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                variant: "primary",
                href: "/reset-password",
                analyticsName: "".concat(analyticsName, "-forgot-password"),
                target: openForgotPasswordInNewTab ? "_blank" : "_self",
                "aria-label": openForgotPasswordInNewTab ? forgotPasswordAriaNewWindow : forgotPasswordAriaSameWindow,
                margin: "auto",
                children: forgotPasswordText
            })
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/i18n/index.mjs + 16 modules
var i18n = __webpack_require__(456978);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/shared.mjs
var shared = __webpack_require__(768759);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/AccountEmailForm.mjs










function cov_1ymkl8lrj8() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountEmailForm.tsx";
    var hash = "140da8e7625fea18f8266cf92e22d98b1e2a8193";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountEmailForm.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 33,
                    column: 25
                },
                end: {
                    line: 152,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 48,
                    column: 44
                },
                end: {
                    line: 48,
                    column: 74
                }
            },
            "2": {
                start: {
                    line: 49,
                    column: 30
                },
                end: {
                    line: 49,
                    column: 60
                }
            },
            "3": {
                start: {
                    line: 51,
                    column: 36
                },
                end: {
                    line: 51,
                    column: 60
                }
            },
            "4": {
                start: {
                    line: 53,
                    column: 30
                },
                end: {
                    line: 61,
                    column: 5
                }
            },
            "5": {
                start: {
                    line: 54,
                    column: 18
                },
                end: {
                    line: 54,
                    column: 47
                }
            },
            "6": {
                start: {
                    line: 55,
                    column: 21
                },
                end: {
                    line: 55,
                    column: 58
                }
            },
            "7": {
                start: {
                    line: 58,
                    column: 6
                },
                end: {
                    line: 60,
                    column: 7
                }
            },
            "8": {
                start: {
                    line: 59,
                    column: 8
                },
                end: {
                    line: 59,
                    column: 61
                }
            },
            "9": {
                start: {
                    line: 63,
                    column: 4
                },
                end: {
                    line: 66,
                    column: 11
                }
            },
            "10": {
                start: {
                    line: 64,
                    column: 6
                },
                end: {
                    line: 64,
                    column: 26
                }
            },
            "11": {
                start: {
                    line: 68,
                    column: 25
                },
                end: {
                    line: 76,
                    column: 5
                }
            },
            "12": {
                start: {
                    line: 69,
                    column: 6
                },
                end: {
                    line: 69,
                    column: 25
                }
            },
            "13": {
                start: {
                    line: 70,
                    column: 6
                },
                end: {
                    line: 72,
                    column: 7
                }
            },
            "14": {
                start: {
                    line: 71,
                    column: 8
                },
                end: {
                    line: 71,
                    column: 24
                }
            },
            "15": {
                start: {
                    line: 73,
                    column: 6
                },
                end: {
                    line: 75,
                    column: 7
                }
            },
            "16": {
                start: {
                    line: 74,
                    column: 8
                },
                end: {
                    line: 74,
                    column: 28
                }
            },
            "17": {
                start: {
                    line: 78,
                    column: 33
                },
                end: {
                    line: 83,
                    column: 5
                }
            },
            "18": {
                start: {
                    line: 79,
                    column: 6
                },
                end: {
                    line: 79,
                    column: 40
                }
            },
            "19": {
                start: {
                    line: 80,
                    column: 6
                },
                end: {
                    line: 82,
                    column: 7
                }
            },
            "20": {
                start: {
                    line: 81,
                    column: 8
                },
                end: {
                    line: 81,
                    column: 28
                }
            },
            "21": {
                start: {
                    line: 87,
                    column: 36
                },
                end: {
                    line: 87,
                    column: 58
                }
            },
            "22": {
                start: {
                    line: 90,
                    column: 23
                },
                end: {
                    line: 90,
                    column: 41
                }
            },
            "23": {
                start: {
                    line: 93,
                    column: 36
                },
                end: {
                    line: 96,
                    column: 5
                }
            },
            "24": {
                start: {
                    line: 94,
                    column: 6
                },
                end: {
                    line: 94,
                    column: 22
                }
            },
            "25": {
                start: {
                    line: 95,
                    column: 6
                },
                end: {
                    line: 95,
                    column: 26
                }
            },
            "26": {
                start: {
                    line: 98,
                    column: 4
                },
                end: {
                    line: 150,
                    column: 6
                }
            },
            "27": {
                start: {
                    line: 126,
                    column: 16
                },
                end: {
                    line: 126,
                    column: 85
                }
            },
            "28": {
                start: {
                    line: 154,
                    column: 0
                },
                end: {
                    line: 154,
                    column: 50
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 34,
                        column: 2
                    },
                    end: {
                        line: 34,
                        column: 3
                    }
                },
                loc: {
                    start: {
                        line: 47,
                        column: 7
                    },
                    end: {
                        line: 151,
                        column: 3
                    }
                },
                line: 47
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 53,
                        column: 30
                    },
                    end: {
                        line: 53,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 36
                    },
                    end: {
                        line: 61,
                        column: 5
                    }
                },
                line: 53
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 63,
                        column: 14
                    },
                    end: {
                        line: 63,
                        column: 15
                    }
                },
                loc: {
                    start: {
                        line: 63,
                        column: 20
                    },
                    end: {
                        line: 66,
                        column: 5
                    }
                },
                line: 63
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 68,
                        column: 25
                    },
                    end: {
                        line: 68,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 68,
                        column: 66
                    },
                    end: {
                        line: 76,
                        column: 5
                    }
                },
                line: 68
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 78,
                        column: 33
                    },
                    end: {
                        line: 78,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 78,
                        column: 47
                    },
                    end: {
                        line: 83,
                        column: 5
                    }
                },
                line: 78
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 93,
                        column: 36
                    },
                    end: {
                        line: 93,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 93,
                        column: 87
                    },
                    end: {
                        line: 96,
                        column: 5
                    }
                },
                line: 93
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 125,
                        column: 24
                    },
                    end: {
                        line: 125,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 126,
                        column: 16
                    },
                    end: {
                        line: 126,
                        column: 85
                    }
                },
                line: 126
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 36,
                        column: 6
                    },
                    end: {
                        line: 36,
                        column: 31
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 36,
                            column: 27
                        },
                        end: {
                            line: 36,
                            column: 31
                        }
                    }
                ],
                line: 36
            },
            "1": {
                loc: {
                    start: {
                        line: 41,
                        column: 13
                    },
                    end: {
                        line: 41,
                        column: 30
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 41,
                            column: 28
                        },
                        end: {
                            line: 41,
                            column: 30
                        }
                    }
                ],
                line: 41
            },
            "2": {
                loc: {
                    start: {
                        line: 58,
                        column: 6
                    },
                    end: {
                        line: 60,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 58,
                            column: 6
                        },
                        end: {
                            line: 60,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 58
            },
            "3": {
                loc: {
                    start: {
                        line: 59,
                        column: 24
                    },
                    end: {
                        line: 59,
                        column: 59
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 59,
                            column: 24
                        },
                        end: {
                            line: 59,
                            column: 43
                        }
                    },
                    {
                        start: {
                            line: 59,
                            column: 47
                        },
                        end: {
                            line: 59,
                            column: 59
                        }
                    }
                ],
                line: 59
            },
            "4": {
                loc: {
                    start: {
                        line: 70,
                        column: 6
                    },
                    end: {
                        line: 72,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 70,
                            column: 6
                        },
                        end: {
                            line: 72,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 70
            },
            "5": {
                loc: {
                    start: {
                        line: 73,
                        column: 6
                    },
                    end: {
                        line: 75,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 73,
                            column: 6
                        },
                        end: {
                            line: 75,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 73
            },
            "6": {
                loc: {
                    start: {
                        line: 73,
                        column: 10
                    },
                    end: {
                        line: 73,
                        column: 48
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 73,
                            column: 10
                        },
                        end: {
                            line: 73,
                            column: 13
                        }
                    },
                    {
                        start: {
                            line: 73,
                            column: 17
                        },
                        end: {
                            line: 73,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 73,
                            column: 37
                        },
                        end: {
                            line: 73,
                            column: 48
                        }
                    }
                ],
                line: 73
            },
            "7": {
                loc: {
                    start: {
                        line: 80,
                        column: 6
                    },
                    end: {
                        line: 82,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 80,
                            column: 6
                        },
                        end: {
                            line: 82,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 80
            },
            "8": {
                loc: {
                    start: {
                        line: 80,
                        column: 10
                    },
                    end: {
                        line: 80,
                        column: 72
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 80,
                            column: 10
                        },
                        end: {
                            line: 80,
                            column: 30
                        }
                    },
                    {
                        start: {
                            line: 80,
                            column: 34
                        },
                        end: {
                            line: 80,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 80,
                            column: 41
                        },
                        end: {
                            line: 80,
                            column: 57
                        }
                    },
                    {
                        start: {
                            line: 80,
                            column: 61
                        },
                        end: {
                            line: 80,
                            column: 72
                        }
                    }
                ],
                line: 80
            },
            "9": {
                loc: {
                    start: {
                        line: 90,
                        column: 23
                    },
                    end: {
                        line: 90,
                        column: 41
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 90,
                            column: 23
                        },
                        end: {
                            line: 90,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 90,
                            column: 35
                        },
                        end: {
                            line: 90,
                            column: 41
                        }
                    }
                ],
                line: 90
            },
            "10": {
                loc: {
                    start: {
                        line: 101,
                        column: 11
                    },
                    end: {
                        line: 135,
                        column: 11
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 102,
                            column: 12
                        },
                        end: {
                            line: 119,
                            column: 14
                        }
                    },
                    {
                        start: {
                            line: 121,
                            column: 12
                        },
                        end: {
                            line: 134,
                            column: 14
                        }
                    }
                ],
                line: 101
            },
            "11": {
                loc: {
                    start: {
                        line: 108,
                        column: 21
                    },
                    end: {
                        line: 108,
                        column: 57
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 108,
                            column: 21
                        },
                        end: {
                            line: 108,
                            column: 50
                        }
                    },
                    {
                        start: {
                            line: 108,
                            column: 54
                        },
                        end: {
                            line: 108,
                            column: 57
                        }
                    }
                ],
                line: 108
            },
            "12": {
                loc: {
                    start: {
                        line: 126,
                        column: 25
                    },
                    end: {
                        line: 126,
                        column: 84
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 126,
                            column: 57
                        },
                        end: {
                            line: 126,
                            column: 59
                        }
                    },
                    {
                        start: {
                            line: 126,
                            column: 62
                        },
                        end: {
                            line: 126,
                            column: 84
                        }
                    }
                ],
                line: 126
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0,
                0,
                0
            ],
            "9": [
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0
            ],
            "12": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "140da8e7625fea18f8266cf92e22d98b1e2a8193"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_1ymkl8lrj8 = function cov_1ymkl8lrj8() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1ymkl8lrj8();







function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}





var AccountEmailForm = (cov_1ymkl8lrj8().s[0]++, /*#__PURE__*/ (0,react.forwardRef)(function(_ref, ref) {
    var _ref$showForgotPasswo = _ref.showForgotPassword, showForgotPassword = _ref$showForgotPasswo === void 0 ? (cov_1ymkl8lrj8().b[0][0]++, true) : _ref$showForgotPasswo, analyticsName = _ref.analyticsName, loading = _ref.loading, openForgotPasswordInNewTab = _ref.openForgotPasswordInNewTab, onSubmit = _ref.onSubmit, _ref$email = _ref.email, initialEmail = _ref$email === void 0 ? (cov_1ymkl8lrj8().b[1][0]++, "") : _ref$email, CustomEmailInput = _ref.CustomEmailInput, customEmailValidityCheck = _ref.customEmailValidityCheck, customEmailValidityCheckDelay = _ref.customEmailValidityCheckDelay;
    cov_1ymkl8lrj8().f[0]++;
    var _ref2 = (cov_1ymkl8lrj8().s[1]++, (0,react.useState)(initialEmail)), _ref3 = _slicedToArray(_ref2, 2), prefillEmail = _ref3[0], setPrefillEmail = _ref3[1];
    var _ref4 = (cov_1ymkl8lrj8().s[2]++, (0,react.useState)(initialEmail)), _ref5 = _slicedToArray(_ref4, 2), email = _ref5[0], setEmail = _ref5[1];
    var _ref6 = (cov_1ymkl8lrj8().s[3]++, (0,react.useState)(false)), _ref7 = _slicedToArray(_ref6, 2), hasError = _ref7[0], setHasError = _ref7[1];
    cov_1ymkl8lrj8().s[4]++;
    var maybePrefillEmail = function maybePrefillEmail() {
        cov_1ymkl8lrj8().f[1]++;
        var url = (cov_1ymkl8lrj8().s[5]++, new URL(window.location.href));
        var params = (cov_1ymkl8lrj8().s[6]++, new URLSearchParams(url.searchParams));
        // Update state on mount only if there is a query param override
        cov_1ymkl8lrj8().s[7]++;
        if (params.get("email")) {
            cov_1ymkl8lrj8().b[2][0]++;
            cov_1ymkl8lrj8().s[8]++;
            setPrefillEmail((cov_1ymkl8lrj8().b[3][0]++, params.get("email")) || (cov_1ymkl8lrj8().b[3][1]++, initialEmail));
        } else {
            cov_1ymkl8lrj8().b[2][1]++;
        }
    };
    cov_1ymkl8lrj8().s[9]++;
    (0,react.useEffect)(function() {
        cov_1ymkl8lrj8().f[2]++;
        cov_1ymkl8lrj8().s[10]++;
        maybePrefillEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    cov_1ymkl8lrj8().s[11]++;
    var handleSubmit = function handleSubmit(e) {
        cov_1ymkl8lrj8().f[3]++;
        cov_1ymkl8lrj8().s[12]++;
        e.preventDefault();
        cov_1ymkl8lrj8().s[13]++;
        if (!hasError) {
            cov_1ymkl8lrj8().b[4][0]++;
            cov_1ymkl8lrj8().s[14]++;
            onSubmit(email);
        } else {
            cov_1ymkl8lrj8().b[4][1]++;
        }
        cov_1ymkl8lrj8().s[15]++;
        if ((cov_1ymkl8lrj8().b[6][0]++, ref) && (cov_1ymkl8lrj8().b[6][1]++, "current" in ref) && (cov_1ymkl8lrj8().b[6][2]++, ref.current)) {
            cov_1ymkl8lrj8().b[5][0]++;
            cov_1ymkl8lrj8().s[16]++;
            ref.current.focus();
        } else {
            cov_1ymkl8lrj8().b[5][1]++;
        }
    };
    cov_1ymkl8lrj8().s[17]++;
    var handleValidityChange = function handleValidityChange(validity) {
        cov_1ymkl8lrj8().f[4]++;
        cov_1ymkl8lrj8().s[18]++;
        setHasError(validity !== "valid");
        cov_1ymkl8lrj8().s[19]++;
        if ((cov_1ymkl8lrj8().b[8][0]++, validity !== "valid") && (cov_1ymkl8lrj8().b[8][1]++, ref) && (cov_1ymkl8lrj8().b[8][2]++, "current" in ref) && (cov_1ymkl8lrj8().b[8][3]++, ref.current)) {
            cov_1ymkl8lrj8().b[7][0]++;
            cov_1ymkl8lrj8().s[20]++;
            ref.current.focus();
        } else {
            cov_1ymkl8lrj8().b[7][1]++;
        }
    };
    // Disable email suggestions if locale is Spanish simply because
    // we don't have an easy way to translate suggestions in bricks-next yet
    var disableEmailSuggestions = (cov_1ymkl8lrj8().s[21]++, i18n/* default.language */.Z.language === "es");
    // Disable the form if it has an error or if email is not set.
    var isDisabled = (cov_1ymkl8lrj8().s[22]++, (cov_1ymkl8lrj8().b[9][0]++, hasError) || (cov_1ymkl8lrj8().b[9][1]++, !email));
    // Handler for custom email input (legacy format)
    cov_1ymkl8lrj8().s[23]++;
    var handleCustomEmailChange = function handleCustomEmailChange(event, value, valid) {
        cov_1ymkl8lrj8().f[5]++;
        cov_1ymkl8lrj8().s[24]++;
        setEmail(value);
        cov_1ymkl8lrj8().s[25]++;
        setHasError(!valid);
    };
    cov_1ymkl8lrj8().s[26]++;
    return /*#__PURE__*/ react.createElement(shared/* Form */.l0, {
        onSubmitCapture: handleSubmit
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$4x"
    }, CustomEmailInput ? (cov_1ymkl8lrj8().b[10][0]++, /*#__PURE__*/ react.createElement(CustomEmailInput, {
        analyticsName: analyticsName,
        required: true,
        unboundedWidth: false,
        value: prefillEmail,
        onChange: handleCustomEmailChange,
        delay: (cov_1ymkl8lrj8().b[11][0]++, customEmailValidityCheckDelay) || (cov_1ymkl8lrj8().b[11][1]++, 500),
        label: (0,translationHelper.t)("email"),
        type: "email",
        id: "email-login-input",
        name: "email",
        minLength: 3,
        errorMessage: (0,translationHelper.t)("invalidEmailError"),
        placeholder: "",
        width: "100%",
        customEmailValidityCheck: customEmailValidityCheck,
        autoComplete: "email"
    })) : (cov_1ymkl8lrj8().b[10][1]++, /*#__PURE__*/ react.createElement(EmailInput, {
        ref: ref,
        analyticsName: analyticsName,
        title: (0,translationHelper.t)("email"),
        getValue: function getValue(value) {
            cov_1ymkl8lrj8().f[6]++;
            cov_1ymkl8lrj8().s[27]++;
            return setEmail(isNil_default()(value.unformattedValue) ? (cov_1ymkl8lrj8().b[12][0]++, "") : (cov_1ymkl8lrj8().b[12][1]++, value.unformattedValue));
        },
        disableSuggestions: disableEmailSuggestions,
        onValidationChange: handleValidityChange,
        prefilledValue: prefillEmail,
        fieldRequiredError: (0,translationHelper.t)("fieldRequiredError"),
        invalidEmailError: (0,translationHelper.t)("invalidEmailError"),
        size: "medium"
    })), /*#__PURE__*/ react.createElement(AccountFormControls, {
        actionText: (0,translationHelper.t)("continueWithEmail"),
        analyticsName: analyticsName,
        loading: loading,
        disabled: isDisabled,
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        submitA11yProps: {
            "aria-label": ""
        },
        showForgotPassword: showForgotPassword,
        forgotPasswordText: (0,translationHelper.t)("forgotPassword"),
        forgotPasswordAriaNewWindow: (0,translationHelper.t)("forgotPasswordAriaNewWindow"),
        forgotPasswordAriaSameWindow: (0,translationHelper.t)("forgotPasswordAriaSameWindow")
    })));
}));
cov_1ymkl8lrj8().s[28]++;
AccountEmailForm.displayName = "AccountEmailForm";
/* harmony default export */ var auth_AccountEmailForm = (AccountEmailForm); //# sourceMappingURL=AccountEmailForm.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/AccountFormSubHeader.mjs
function cov_11ycoazp6o() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountFormSubHeader.tsx";
    var hash = "01fdef5791b7f71e38c333aec32de7e4993a8a81";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountFormSubHeader.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 18,
                    column: 67
                },
                end: {
                    line: 54,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 28,
                    column: 21
                },
                end: {
                    line: 28,
                    column: 65
                }
            },
            "2": {
                start: {
                    line: 29,
                    column: 24
                },
                end: {
                    line: 29,
                    column: 83
                }
            },
            "3": {
                start: {
                    line: 31,
                    column: 2
                },
                end: {
                    line: 53,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 18,
                        column: 67
                    },
                    end: {
                        line: 18,
                        column: 68
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 6
                    },
                    end: {
                        line: 54,
                        column: 1
                    }
                },
                line: 27
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 28,
                        column: 21
                    },
                    end: {
                        line: 28,
                        column: 65
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 28,
                            column: 34
                        },
                        end: {
                            line: 28,
                            column: 48
                        }
                    },
                    {
                        start: {
                            line: 28,
                            column: 51
                        },
                        end: {
                            line: 28,
                            column: 65
                        }
                    }
                ],
                line: 28
            },
            "1": {
                loc: {
                    start: {
                        line: 29,
                        column: 24
                    },
                    end: {
                        line: 29,
                        column: 83
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 29,
                            column: 37
                        },
                        end: {
                            line: 29,
                            column: 62
                        }
                    },
                    {
                        start: {
                            line: 29,
                            column: 65
                        },
                        end: {
                            line: 29,
                            column: 83
                        }
                    }
                ],
                line: 29
            },
            "2": {
                loc: {
                    start: {
                        line: 33,
                        column: 7
                    },
                    end: {
                        line: 37,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 33,
                            column: 7
                        },
                        end: {
                            line: 33,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 34,
                            column: 8
                        },
                        end: {
                            line: 36,
                            column: 15
                        }
                    }
                ],
                line: 33
            },
            "3": {
                loc: {
                    start: {
                        line: 38,
                        column: 7
                    },
                    end: {
                        line: 51,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 38,
                            column: 7
                        },
                        end: {
                            line: 38,
                            column: 24
                        }
                    },
                    {
                        start: {
                            line: 38,
                            column: 28
                        },
                        end: {
                            line: 38,
                            column: 46
                        }
                    },
                    {
                        start: {
                            line: 38,
                            column: 50
                        },
                        end: {
                            line: 38,
                            column: 73
                        }
                    },
                    {
                        start: {
                            line: 39,
                            column: 8
                        },
                        end: {
                            line: 50,
                            column: 15
                        }
                    }
                ],
                line: 38
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0
        },
        f: {
            "0": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0,
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "01fdef5791b7f71e38c333aec32de7e4993a8a81"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_11ycoazp6o = function cov_11ycoazp6o() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_11ycoazp6o();



cov_11ycoazp6o().s[0]++;
var AccountFormSubHeader = function AccountFormSubHeader(_ref) {
    var loginSubHeaderText = _ref.loginSubHeaderText, registrationSubHeaderText = _ref.registrationSubHeaderText, email = _ref.email, onValidEmailReset = _ref.onValidEmailReset, hasSubmittedEmail = _ref.hasSubmittedEmail, isNewHuman = _ref.isNewHuman, hidePasswordField = _ref.hidePasswordField, phoneNumberInputHidden = _ref.phoneNumberInputHidden;
    cov_11ycoazp6o().f[0]++;
    var actionText = (cov_11ycoazp6o().s[1]++, isNewHuman ? (cov_11ycoazp6o().b[0][0]++, (0,translationHelper.t)("signingUp")) : (cov_11ycoazp6o().b[0][1]++, (0,translationHelper.t)("signingIn")));
    var subHeaderText = (cov_11ycoazp6o().s[2]++, isNewHuman ? (cov_11ycoazp6o().b[1][0]++, registrationSubHeaderText) : (cov_11ycoazp6o().b[1][1]++, loginSubHeaderText));
    cov_11ycoazp6o().s[3]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, null, (cov_11ycoazp6o().b[2][0]++, subHeaderText) && (cov_11ycoazp6o().b[2][1]++, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$subheaderSmall",
        marginTop: "$5x",
        marginBottom: "$5x",
        tag: "h2"
    }, subHeaderText)), (cov_11ycoazp6o().b[3][0]++, hasSubmittedEmail) && (cov_11ycoazp6o().b[3][1]++, !hidePasswordField) && (cov_11ycoazp6o().b[3][2]++, !phoneNumberInputHidden) && (cov_11ycoazp6o().b[3][3]++, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$bodySmall",
        tag: "p",
        gap: "$2x"
    }, actionText, " as", " ", /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: "_",
        size: "small",
        variant: "secondary",
        analyticsName: "Reset email",
        onPress: onValidEmailReset
    }, email))));
};
/* harmony default export */ var auth_AccountFormSubHeader = (AccountFormSubHeader); //# sourceMappingURL=AccountFormSubHeader.mjs.map

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__(426833);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__(573210);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(2490);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(959849);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/TextInput.js
var TextInput = __webpack_require__(694746);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/forms/NameInput.js





var NameInput = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /* @__PURE__ */ {
    var analyticsName = _param.analyticsName, _invalidNameError = _param.invalidNameError, invalidNameError = _invalidNameError === void 0 ? "Please enter your full name." : _invalidNameError, _title = _param.title, title = _title === void 0 ? "Full name" : _title, _size = _param.size, size = _size === void 0 ? "medium" : _size, _autoComplete = _param.autoComplete, autoComplete = _autoComplete === void 0 ? "name" : _autoComplete, ariaLabelledBy = _param.ariaLabelledBy, props = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "invalidNameError",
        "title",
        "size",
        "autoComplete",
        "ariaLabelledBy"
    ]);
    return (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,_object_spread/* default */.Z)({
        ref: ref,
        id: "name",
        analyticsName: "".concat(analyticsName, "-name"),
        size: size,
        autoComplete: autoComplete,
        errorText: props.errorText || invalidNameError
    }, ariaLabelledBy ? {
        ariaLabelledBy: ariaLabelledBy
    } : {
        title: title
    }, props));
});
NameInput.displayName = "NameInput";


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/forms/AccountPasswordInput.js





var AccountPasswordInput = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /* @__PURE__ */ {
    var analyticsName = _param.analyticsName, _supportText = _param.supportText, supportText = _supportText === void 0 ? "5-128 characters" : _supportText, customValidator = _param.customValidator, validationErrorText = _param.validationErrorText, _title = _param.title, title = _title === void 0 ? "Password" : _title, _size = _param.size, size = _size === void 0 ? "medium" : _size, _required = _param.required, required = _required === void 0 ? !0 : _required, ariaLabelledBy = _param.ariaLabelledBy, props = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "supportText",
        "customValidator",
        "validationErrorText",
        "title",
        "size",
        "required",
        "ariaLabelledBy"
    ]);
    return (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, (0,_object_spread/* default */.Z)({
        ref: ref,
        id: "password",
        analyticsName: "".concat(analyticsName, "-password"),
        size: size,
        required: required,
        textContentType: "password",
        supportText: supportText
    }, ariaLabelledBy ? {
        ariaLabelledBy: ariaLabelledBy
    } : {
        title: title
    }, props));
});
AccountPasswordInput.displayName = "AccountPasswordInput";


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/forms/PhoneInput.js





var PhoneInput = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) /* @__PURE__ */ {
    var analyticsName = _param.analyticsName, _invalidPhoneError = _param.invalidPhoneError, invalidPhoneError = _invalidPhoneError === void 0 ? "Please enter a valid phone number." : _invalidPhoneError, _fieldRequiredError = _param.fieldRequiredError, fieldRequiredError = _fieldRequiredError === void 0 ? "This field is required." : _fieldRequiredError, _title = _param.title, title = _title === void 0 ? "Phone number" : _title, _size = _param.size, size = _size === void 0 ? "medium" : _size, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "000-000-0000" : _placeholder, ariaLabelledBy = _param.ariaLabelledBy, props = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "invalidPhoneError",
        "fieldRequiredError",
        "title",
        "size",
        "placeholder",
        "ariaLabelledBy"
    ]);
    return (0,jsx_runtime.jsx)(ValidatedTextInput/* ValidatedTextInput */.O, (0,_object_spread/* default */.Z)({
        ref: ref,
        id: "phone",
        analyticsName: "".concat(analyticsName, "-phone"),
        format: "telephoneNumber",
        size: size,
        placeholder: placeholder,
        customErrorMessages: {
            fieldRequired: fieldRequiredError,
            invalidPhoneNumber: invalidPhoneError
        }
    }, ariaLabelledBy ? {
        ariaLabelledBy: ariaLabelledBy
    } : {
        title: title
    }, props));
});
PhoneInput.displayName = "PhoneInput";


// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/checkboxRadio/SimpleCheckbox.js
var SimpleCheckbox = __webpack_require__(44468);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/AccountPasswordForm.mjs

function cov_2cjzfzrvji() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountPasswordForm.tsx";
    var hash = "afc6a596995fb6b616ab7211278da84d16592d41";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountPasswordForm.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 71,
                    column: 28
                },
                end: {
                    line: 460,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 101,
                    column: 20
                },
                end: {
                    line: 101,
                    column: 54
                }
            },
            "2": {
                start: {
                    line: 103,
                    column: 36
                },
                end: {
                    line: 103,
                    column: 60
                }
            },
            "3": {
                start: {
                    line: 104,
                    column: 28
                },
                end: {
                    line: 104,
                    column: 63
                }
            },
            "4": {
                start: {
                    line: 105,
                    column: 41
                },
                end: {
                    line: 105,
                    column: 65
                }
            },
            "5": {
                start: {
                    line: 106,
                    column: 52
                },
                end: {
                    line: 106,
                    column: 76
                }
            },
            "6": {
                start: {
                    line: 107,
                    column: 30
                },
                end: {
                    line: 107,
                    column: 66
                }
            },
            "7": {
                start: {
                    line: 108,
                    column: 46
                },
                end: {
                    line: 108,
                    column: 70
                }
            },
            "8": {
                start: {
                    line: 109,
                    column: 43
                },
                end: {
                    line: 109,
                    column: 87
                }
            },
            "9": {
                start: {
                    line: 110,
                    column: 36
                },
                end: {
                    line: 110,
                    column: 56
                }
            },
            "10": {
                start: {
                    line: 111,
                    column: 40
                },
                end: {
                    line: 115,
                    column: 10
                }
            },
            "11": {
                start: {
                    line: 117,
                    column: 26
                },
                end: {
                    line: 131,
                    column: 5
                }
            },
            "12": {
                start: {
                    line: 119,
                    column: 8
                },
                end: {
                    line: 121,
                    column: 9
                }
            },
            "13": {
                start: {
                    line: 120,
                    column: 10
                },
                end: {
                    line: 120,
                    column: 71
                }
            },
            "14": {
                start: {
                    line: 125,
                    column: 8
                },
                end: {
                    line: 128,
                    column: 10
                }
            },
            "15": {
                start: {
                    line: 133,
                    column: 32
                },
                end: {
                    line: 144,
                    column: 37
                }
            },
            "16": {
                start: {
                    line: 134,
                    column: 18
                },
                end: {
                    line: 134,
                    column: 47
                }
            },
            "17": {
                start: {
                    line: 135,
                    column: 21
                },
                end: {
                    line: 135,
                    column: 58
                }
            },
            "18": {
                start: {
                    line: 136,
                    column: 26
                },
                end: {
                    line: 136,
                    column: 67
                }
            },
            "19": {
                start: {
                    line: 137,
                    column: 34
                },
                end: {
                    line: 137,
                    column: 60
                }
            },
            "20": {
                start: {
                    line: 139,
                    column: 6
                },
                end: {
                    line: 143,
                    column: 7
                }
            },
            "21": {
                start: {
                    line: 140,
                    column: 8
                },
                end: {
                    line: 140,
                    column: 36
                }
            },
            "22": {
                start: {
                    line: 141,
                    column: 8
                },
                end: {
                    line: 141,
                    column: 40
                }
            },
            "23": {
                start: {
                    line: 142,
                    column: 8
                },
                end: {
                    line: 142,
                    column: 32
                }
            },
            "24": {
                start: {
                    line: 146,
                    column: 4
                },
                end: {
                    line: 151,
                    column: 39
                }
            },
            "25": {
                start: {
                    line: 147,
                    column: 6
                },
                end: {
                    line: 147,
                    column: 28
                }
            },
            "26": {
                start: {
                    line: 148,
                    column: 6
                },
                end: {
                    line: 150,
                    column: 7
                }
            },
            "27": {
                start: {
                    line: 149,
                    column: 8
                },
                end: {
                    line: 149,
                    column: 37
                }
            },
            "28": {
                start: {
                    line: 153,
                    column: 35
                },
                end: {
                    line: 153,
                    column: 95
                }
            },
            "29": {
                start: {
                    line: 153,
                    column: 49
                },
                end: {
                    line: 153,
                    column: 95
                }
            },
            "30": {
                start: {
                    line: 155,
                    column: 57
                },
                end: {
                    line: 165,
                    column: 5
                }
            },
            "31": {
                start: {
                    line: 156,
                    column: 6
                },
                end: {
                    line: 156,
                    column: 20
                }
            },
            "32": {
                start: {
                    line: 157,
                    column: 26
                },
                end: {
                    line: 157,
                    column: 52
                }
            },
            "33": {
                start: {
                    line: 158,
                    column: 26
                },
                end: {
                    line: 158,
                    column: 44
                }
            },
            "34": {
                start: {
                    line: 160,
                    column: 6
                },
                end: {
                    line: 164,
                    column: 7
                }
            },
            "35": {
                start: {
                    line: 161,
                    column: 8
                },
                end: {
                    line: 161,
                    column: 57
                }
            },
            "36": {
                start: {
                    line: 163,
                    column: 8
                },
                end: {
                    line: 163,
                    column: 50
                }
            },
            "37": {
                start: {
                    line: 167,
                    column: 58
                },
                end: {
                    line: 172,
                    column: 5
                }
            },
            "38": {
                start: {
                    line: 168,
                    column: 34
                },
                end: {
                    line: 168,
                    column: 54
                }
            },
            "39": {
                start: {
                    line: 170,
                    column: 6
                },
                end: {
                    line: 170,
                    column: 22
                }
            },
            "40": {
                start: {
                    line: 171,
                    column: 6
                },
                end: {
                    line: 171,
                    column: 30
                }
            },
            "41": {
                start: {
                    line: 174,
                    column: 61
                },
                end: {
                    line: 181,
                    column: 5
                }
            },
            "42": {
                start: {
                    line: 176,
                    column: 6
                },
                end: {
                    line: 176,
                    column: 33
                }
            },
            "43": {
                start: {
                    line: 179,
                    column: 6
                },
                end: {
                    line: 179,
                    column: 72
                }
            },
            "44": {
                start: {
                    line: 180,
                    column: 6
                },
                end: {
                    line: 180,
                    column: 28
                }
            },
            "45": {
                start: {
                    line: 183,
                    column: 25
                },
                end: {
                    line: 216,
                    column: 5
                }
            },
            "46": {
                start: {
                    line: 184,
                    column: 6
                },
                end: {
                    line: 184,
                    column: 25
                }
            },
            "47": {
                start: {
                    line: 186,
                    column: 6
                },
                end: {
                    line: 188,
                    column: 7
                }
            },
            "48": {
                start: {
                    line: 187,
                    column: 8
                },
                end: {
                    line: 187,
                    column: 15
                }
            },
            "49": {
                start: {
                    line: 190,
                    column: 6
                },
                end: {
                    line: 198,
                    column: 7
                }
            },
            "50": {
                start: {
                    line: 197,
                    column: 8
                },
                end: {
                    line: 197,
                    column: 15
                }
            },
            "51": {
                start: {
                    line: 200,
                    column: 6
                },
                end: {
                    line: 209,
                    column: 7
                }
            },
            "52": {
                start: {
                    line: 201,
                    column: 8
                },
                end: {
                    line: 206,
                    column: 9
                }
            },
            "53": {
                start: {
                    line: 202,
                    column: 10
                },
                end: {
                    line: 202,
                    column: 62
                }
            },
            "54": {
                start: {
                    line: 205,
                    column: 10
                },
                end: {
                    line: 205,
                    column: 44
                }
            },
            "55": {
                start: {
                    line: 208,
                    column: 8
                },
                end: {
                    line: 208,
                    column: 26
                }
            },
            "56": {
                start: {
                    line: 211,
                    column: 6
                },
                end: {
                    line: 215,
                    column: 9
                }
            },
            "57": {
                start: {
                    line: 219,
                    column: 6
                },
                end: {
                    line: 221,
                    column: 87
                }
            },
            "58": {
                start: {
                    line: 223,
                    column: 21
                },
                end: {
                    line: 223,
                    column: 33
                }
            },
            "59": {
                start: {
                    line: 224,
                    column: 4
                },
                end: {
                    line: 228,
                    column: 5
                }
            },
            "60": {
                start: {
                    line: 225,
                    column: 6
                },
                end: {
                    line: 225,
                    column: 29
                }
            },
            "61": {
                start: {
                    line: 226,
                    column: 11
                },
                end: {
                    line: 228,
                    column: 5
                }
            },
            "62": {
                start: {
                    line: 227,
                    column: 6
                },
                end: {
                    line: 227,
                    column: 33
                }
            },
            "63": {
                start: {
                    line: 230,
                    column: 4
                },
                end: {
                    line: 232,
                    column: 5
                }
            },
            "64": {
                start: {
                    line: 231,
                    column: 6
                },
                end: {
                    line: 231,
                    column: 42
                }
            },
            "65": {
                start: {
                    line: 234,
                    column: 40
                },
                end: {
                    line: 234,
                    column: 70
                }
            },
            "66": {
                start: {
                    line: 235,
                    column: 26
                },
                end: {
                    line: 235,
                    column: 67
                }
            },
            "67": {
                start: {
                    line: 236,
                    column: 26
                },
                end: {
                    line: 236,
                    column: 81
                }
            },
            "68": {
                start: {
                    line: 238,
                    column: 43
                },
                end: {
                    line: 238,
                    column: 80
                }
            },
            "69": {
                start: {
                    line: 240,
                    column: 43
                },
                end: {
                    line: 240,
                    column: 74
                }
            },
            "70": {
                start: {
                    line: 242,
                    column: 4
                },
                end: {
                    line: 249,
                    column: 47
                }
            },
            "71": {
                start: {
                    line: 243,
                    column: 6
                },
                end: {
                    line: 247,
                    column: 7
                }
            },
            "72": {
                start: {
                    line: 244,
                    column: 8
                },
                end: {
                    line: 246,
                    column: 9
                }
            },
            "73": {
                start: {
                    line: 245,
                    column: 10
                },
                end: {
                    line: 245,
                    column: 30
                }
            },
            "74": {
                start: {
                    line: 252,
                    column: 35
                },
                end: {
                    line: 254,
                    column: 5
                }
            },
            "75": {
                start: {
                    line: 253,
                    column: 6
                },
                end: {
                    line: 253,
                    column: 26
                }
            },
            "76": {
                start: {
                    line: 256,
                    column: 36
                },
                end: {
                    line: 258,
                    column: 5
                }
            },
            "77": {
                start: {
                    line: 257,
                    column: 6
                },
                end: {
                    line: 257,
                    column: 27
                }
            },
            "78": {
                start: {
                    line: 260,
                    column: 39
                },
                end: {
                    line: 262,
                    column: 5
                }
            },
            "79": {
                start: {
                    line: 261,
                    column: 6
                },
                end: {
                    line: 261,
                    column: 30
                }
            },
            "80": {
                start: {
                    line: 264,
                    column: 4
                },
                end: {
                    line: 458,
                    column: 6
                }
            },
            "81": {
                start: {
                    line: 332,
                    column: 22
                },
                end: {
                    line: 332,
                    column: 100
                }
            },
            "82": {
                start: {
                    line: 377,
                    column: 24
                },
                end: {
                    line: 379,
                    column: 25
                }
            },
            "83": {
                start: {
                    line: 378,
                    column: 26
                },
                end: {
                    line: 378,
                    column: 52
                }
            },
            "84": {
                start: {
                    line: 462,
                    column: 0
                },
                end: {
                    line: 462,
                    column: 56
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 72,
                        column: 2
                    },
                    end: {
                        line: 72,
                        column: 3
                    }
                },
                loc: {
                    start: {
                        line: 100,
                        column: 7
                    },
                    end: {
                        line: 459,
                        column: 3
                    }
                },
                line: 100
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 118,
                        column: 6
                    },
                    end: {
                        line: 118,
                        column: 7
                    }
                },
                loc: {
                    start: {
                        line: 118,
                        column: 26
                    },
                    end: {
                        line: 129,
                        column: 7
                    }
                },
                line: 118
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 133,
                        column: 44
                    },
                    end: {
                        line: 133,
                        column: 45
                    }
                },
                loc: {
                    start: {
                        line: 133,
                        column: 50
                    },
                    end: {
                        line: 144,
                        column: 5
                    }
                },
                line: 133
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 146,
                        column: 14
                    },
                    end: {
                        line: 146,
                        column: 15
                    }
                },
                loc: {
                    start: {
                        line: 146,
                        column: 20
                    },
                    end: {
                        line: 151,
                        column: 5
                    }
                },
                line: 146
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 153,
                        column: 35
                    },
                    end: {
                        line: 153,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 153,
                        column: 49
                    },
                    end: {
                        line: 153,
                        column: 95
                    }
                },
                line: 153
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 155,
                        column: 57
                    },
                    end: {
                        line: 155,
                        column: 58
                    }
                },
                loc: {
                    start: {
                        line: 155,
                        column: 67
                    },
                    end: {
                        line: 165,
                        column: 5
                    }
                },
                line: 155
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 167,
                        column: 58
                    },
                    end: {
                        line: 167,
                        column: 59
                    }
                },
                loc: {
                    start: {
                        line: 167,
                        column: 69
                    },
                    end: {
                        line: 172,
                        column: 5
                    }
                },
                line: 167
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 174,
                        column: 61
                    },
                    end: {
                        line: 174,
                        column: 62
                    }
                },
                loc: {
                    start: {
                        line: 174,
                        column: 75
                    },
                    end: {
                        line: 181,
                        column: 5
                    }
                },
                line: 174
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 183,
                        column: 25
                    },
                    end: {
                        line: 183,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 183,
                        column: 75
                    },
                    end: {
                        line: 216,
                        column: 5
                    }
                },
                line: 183
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 242,
                        column: 14
                    },
                    end: {
                        line: 242,
                        column: 15
                    }
                },
                loc: {
                    start: {
                        line: 242,
                        column: 20
                    },
                    end: {
                        line: 249,
                        column: 5
                    }
                },
                line: 242
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 252,
                        column: 35
                    },
                    end: {
                        line: 252,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 252,
                        column: 88
                    },
                    end: {
                        line: 254,
                        column: 5
                    }
                },
                line: 252
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 256,
                        column: 36
                    },
                    end: {
                        line: 256,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 256,
                        column: 89
                    },
                    end: {
                        line: 258,
                        column: 5
                    }
                },
                line: 256
            },
            "12": {
                name: "(anonymous_12)",
                decl: {
                    start: {
                        line: 260,
                        column: 39
                    },
                    end: {
                        line: 260,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 260,
                        column: 92
                    },
                    end: {
                        line: 262,
                        column: 5
                    }
                },
                line: 260
            },
            "13": {
                name: "(anonymous_13)",
                decl: {
                    start: {
                        line: 331,
                        column: 28
                    },
                    end: {
                        line: 331,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 331,
                        column: 34
                    },
                    end: {
                        line: 333,
                        column: 21
                    }
                },
                line: 331
            },
            "14": {
                name: "(anonymous_14)",
                decl: {
                    start: {
                        line: 376,
                        column: 31
                    },
                    end: {
                        line: 376,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 376,
                        column: 47
                    },
                    end: {
                        line: 380,
                        column: 23
                    }
                },
                line: 376
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 87,
                        column: 6
                    },
                    end: {
                        line: 87,
                        column: 37
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 87,
                            column: 33
                        },
                        end: {
                            line: 87,
                            column: 37
                        }
                    }
                ],
                line: 87
            },
            "1": {
                loc: {
                    start: {
                        line: 88,
                        column: 6
                    },
                    end: {
                        line: 88,
                        column: 36
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 88,
                            column: 31
                        },
                        end: {
                            line: 88,
                            column: 36
                        }
                    }
                ],
                line: 88
            },
            "2": {
                loc: {
                    start: {
                        line: 104,
                        column: 45
                    },
                    end: {
                        line: 104,
                        column: 62
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 104,
                            column: 45
                        },
                        end: {
                            line: 104,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 104,
                            column: 60
                        },
                        end: {
                            line: 104,
                            column: 62
                        }
                    }
                ],
                line: 104
            },
            "3": {
                loc: {
                    start: {
                        line: 107,
                        column: 47
                    },
                    end: {
                        line: 107,
                        column: 65
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 107,
                            column: 47
                        },
                        end: {
                            line: 107,
                            column: 59
                        }
                    },
                    {
                        start: {
                            line: 107,
                            column: 63
                        },
                        end: {
                            line: 107,
                            column: 65
                        }
                    }
                ],
                line: 107
            },
            "4": {
                loc: {
                    start: {
                        line: 119,
                        column: 8
                    },
                    end: {
                        line: 121,
                        column: 9
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 119,
                            column: 8
                        },
                        end: {
                            line: 121,
                            column: 9
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 119
            },
            "5": {
                loc: {
                    start: {
                        line: 119,
                        column: 12
                    },
                    end: {
                        line: 119,
                        column: 40
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 119,
                            column: 12
                        },
                        end: {
                            line: 119,
                            column: 24
                        }
                    },
                    {
                        start: {
                            line: 119,
                            column: 28
                        },
                        end: {
                            line: 119,
                            column: 40
                        }
                    }
                ],
                line: 119
            },
            "6": {
                loc: {
                    start: {
                        line: 136,
                        column: 26
                    },
                    end: {
                        line: 136,
                        column: 67
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 136,
                            column: 26
                        },
                        end: {
                            line: 136,
                            column: 51
                        }
                    },
                    {
                        start: {
                            line: 136,
                            column: 55
                        },
                        end: {
                            line: 136,
                            column: 67
                        }
                    }
                ],
                line: 136
            },
            "7": {
                loc: {
                    start: {
                        line: 139,
                        column: 6
                    },
                    end: {
                        line: 143,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 139,
                            column: 6
                        },
                        end: {
                            line: 143,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 139
            },
            "8": {
                loc: {
                    start: {
                        line: 139,
                        column: 10
                    },
                    end: {
                        line: 139,
                        column: 57
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 139,
                            column: 10
                        },
                        end: {
                            line: 139,
                            column: 28
                        }
                    },
                    {
                        start: {
                            line: 139,
                            column: 32
                        },
                        end: {
                            line: 139,
                            column: 57
                        }
                    }
                ],
                line: 139
            },
            "9": {
                loc: {
                    start: {
                        line: 141,
                        column: 17
                    },
                    end: {
                        line: 141,
                        column: 38
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 141,
                            column: 28
                        },
                        end: {
                            line: 141,
                            column: 30
                        }
                    },
                    {
                        start: {
                            line: 141,
                            column: 33
                        },
                        end: {
                            line: 141,
                            column: 38
                        }
                    }
                ],
                line: 141
            },
            "10": {
                loc: {
                    start: {
                        line: 148,
                        column: 6
                    },
                    end: {
                        line: 150,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 148,
                            column: 6
                        },
                        end: {
                            line: 150,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 148
            },
            "11": {
                loc: {
                    start: {
                        line: 153,
                        column: 49
                    },
                    end: {
                        line: 153,
                        column: 95
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 153,
                            column: 49
                        },
                        end: {
                            line: 153,
                            column: 69
                        }
                    },
                    {
                        start: {
                            line: 153,
                            column: 73
                        },
                        end: {
                            line: 153,
                            column: 95
                        }
                    }
                ],
                line: 153
            },
            "12": {
                loc: {
                    start: {
                        line: 157,
                        column: 26
                    },
                    end: {
                        line: 157,
                        column: 52
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 157,
                            column: 26
                        },
                        end: {
                            line: 157,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 157,
                            column: 41
                        },
                        end: {
                            line: 157,
                            column: 52
                        }
                    }
                ],
                line: 157
            },
            "13": {
                loc: {
                    start: {
                        line: 160,
                        column: 6
                    },
                    end: {
                        line: 164,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 160,
                            column: 6
                        },
                        end: {
                            line: 164,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: 162,
                            column: 13
                        },
                        end: {
                            line: 164,
                            column: 7
                        }
                    }
                ],
                line: 160
            },
            "14": {
                loc: {
                    start: {
                        line: 161,
                        column: 21
                    },
                    end: {
                        line: 161,
                        column: 55
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 161,
                            column: 35
                        },
                        end: {
                            line: 161,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 161,
                            column: 43
                        },
                        end: {
                            line: 161,
                            column: 55
                        }
                    }
                ],
                line: 161
            },
            "15": {
                loc: {
                    start: {
                        line: 163,
                        column: 21
                    },
                    end: {
                        line: 163,
                        column: 48
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 163,
                            column: 21
                        },
                        end: {
                            line: 163,
                            column: 32
                        }
                    },
                    {
                        start: {
                            line: 163,
                            column: 36
                        },
                        end: {
                            line: 163,
                            column: 48
                        }
                    }
                ],
                line: 163
            },
            "16": {
                loc: {
                    start: {
                        line: 179,
                        column: 18
                    },
                    end: {
                        line: 179,
                        column: 70
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 179,
                            column: 18
                        },
                        end: {
                            line: 179,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 179,
                            column: 37
                        },
                        end: {
                            line: 179,
                            column: 70
                        }
                    }
                ],
                line: 179
            },
            "17": {
                loc: {
                    start: {
                        line: 186,
                        column: 6
                    },
                    end: {
                        line: 188,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 186,
                            column: 6
                        },
                        end: {
                            line: 188,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 186
            },
            "18": {
                loc: {
                    start: {
                        line: 186,
                        column: 10
                    },
                    end: {
                        line: 186,
                        column: 69
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 186,
                            column: 10
                        },
                        end: {
                            line: 186,
                            column: 18
                        }
                    },
                    {
                        start: {
                            line: 186,
                            column: 23
                        },
                        end: {
                            line: 186,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 186,
                            column: 38
                        },
                        end: {
                            line: 186,
                            column: 50
                        }
                    },
                    {
                        start: {
                            line: 186,
                            column: 54
                        },
                        end: {
                            line: 186,
                            column: 67
                        }
                    }
                ],
                line: 186
            },
            "19": {
                loc: {
                    start: {
                        line: 190,
                        column: 6
                    },
                    end: {
                        line: 198,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 190,
                            column: 6
                        },
                        end: {
                            line: 198,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 190
            },
            "20": {
                loc: {
                    start: {
                        line: 192,
                        column: 8
                    },
                    end: {
                        line: 195,
                        column: 34
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 192,
                            column: 8
                        },
                        end: {
                            line: 192,
                            column: 62
                        }
                    },
                    {
                        start: {
                            line: 193,
                            column: 8
                        },
                        end: {
                            line: 193,
                            column: 32
                        }
                    },
                    {
                        start: {
                            line: 194,
                            column: 8
                        },
                        end: {
                            line: 194,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 195,
                            column: 8
                        },
                        end: {
                            line: 195,
                            column: 34
                        }
                    }
                ],
                line: 192
            },
            "21": {
                loc: {
                    start: {
                        line: 200,
                        column: 6
                    },
                    end: {
                        line: 209,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 200,
                            column: 6
                        },
                        end: {
                            line: 209,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: 207,
                            column: 13
                        },
                        end: {
                            line: 209,
                            column: 7
                        }
                    }
                ],
                line: 200
            },
            "22": {
                loc: {
                    start: {
                        line: 201,
                        column: 8
                    },
                    end: {
                        line: 206,
                        column: 9
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 201,
                            column: 8
                        },
                        end: {
                            line: 206,
                            column: 9
                        }
                    },
                    {
                        start: {
                            line: 203,
                            column: 15
                        },
                        end: {
                            line: 206,
                            column: 9
                        }
                    }
                ],
                line: 201
            },
            "23": {
                loc: {
                    start: {
                        line: 201,
                        column: 12
                    },
                    end: {
                        line: 201,
                        column: 74
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 201,
                            column: 12
                        },
                        end: {
                            line: 201,
                            column: 47
                        }
                    },
                    {
                        start: {
                            line: 201,
                            column: 51
                        },
                        end: {
                            line: 201,
                            column: 74
                        }
                    }
                ],
                line: 201
            },
            "24": {
                loc: {
                    start: {
                        line: 219,
                        column: 6
                    },
                    end: {
                        line: 221,
                        column: 87
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 219,
                            column: 6
                        },
                        end: {
                            line: 219,
                            column: 14
                        }
                    },
                    {
                        start: {
                            line: 220,
                            column: 7
                        },
                        end: {
                            line: 220,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 220,
                            column: 30
                        },
                        end: {
                            line: 220,
                            column: 39
                        }
                    },
                    {
                        start: {
                            line: 220,
                            column: 43
                        },
                        end: {
                            line: 220,
                            column: 64
                        }
                    },
                    {
                        start: {
                            line: 221,
                            column: 7
                        },
                        end: {
                            line: 221,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 221,
                            column: 23
                        },
                        end: {
                            line: 221,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 221,
                            column: 45
                        },
                        end: {
                            line: 221,
                            column: 50
                        }
                    },
                    {
                        start: {
                            line: 221,
                            column: 54
                        },
                        end: {
                            line: 221,
                            column: 66
                        }
                    },
                    {
                        start: {
                            line: 221,
                            column: 72
                        },
                        end: {
                            line: 221,
                            column: 85
                        }
                    }
                ],
                line: 219
            },
            "25": {
                loc: {
                    start: {
                        line: 224,
                        column: 4
                    },
                    end: {
                        line: 228,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 224,
                            column: 4
                        },
                        end: {
                            line: 228,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 226,
                            column: 11
                        },
                        end: {
                            line: 228,
                            column: 5
                        }
                    }
                ],
                line: 224
            },
            "26": {
                loc: {
                    start: {
                        line: 226,
                        column: 11
                    },
                    end: {
                        line: 228,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 226,
                            column: 11
                        },
                        end: {
                            line: 228,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 226
            },
            "27": {
                loc: {
                    start: {
                        line: 230,
                        column: 4
                    },
                    end: {
                        line: 232,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 230,
                            column: 4
                        },
                        end: {
                            line: 232,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 230
            },
            "28": {
                loc: {
                    start: {
                        line: 234,
                        column: 40
                    },
                    end: {
                        line: 234,
                        column: 70
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 234,
                            column: 40
                        },
                        end: {
                            line: 234,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 234,
                            column: 60
                        },
                        end: {
                            line: 234,
                            column: 70
                        }
                    }
                ],
                line: 234
            },
            "29": {
                loc: {
                    start: {
                        line: 235,
                        column: 26
                    },
                    end: {
                        line: 235,
                        column: 67
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 235,
                            column: 26
                        },
                        end: {
                            line: 235,
                            column: 53
                        }
                    },
                    {
                        start: {
                            line: 235,
                            column: 57
                        },
                        end: {
                            line: 235,
                            column: 67
                        }
                    }
                ],
                line: 235
            },
            "30": {
                loc: {
                    start: {
                        line: 236,
                        column: 26
                    },
                    end: {
                        line: 236,
                        column: 81
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 236,
                            column: 39
                        },
                        end: {
                            line: 236,
                            column: 49
                        }
                    },
                    {
                        start: {
                            line: 236,
                            column: 52
                        },
                        end: {
                            line: 236,
                            column: 81
                        }
                    }
                ],
                line: 236
            },
            "31": {
                loc: {
                    start: {
                        line: 238,
                        column: 43
                    },
                    end: {
                        line: 238,
                        column: 80
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 238,
                            column: 43
                        },
                        end: {
                            line: 238,
                            column: 66
                        }
                    },
                    {
                        start: {
                            line: 238,
                            column: 70
                        },
                        end: {
                            line: 238,
                            column: 80
                        }
                    }
                ],
                line: 238
            },
            "32": {
                loc: {
                    start: {
                        line: 243,
                        column: 6
                    },
                    end: {
                        line: 247,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 243,
                            column: 6
                        },
                        end: {
                            line: 247,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 243
            },
            "33": {
                loc: {
                    start: {
                        line: 243,
                        column: 10
                    },
                    end: {
                        line: 243,
                        column: 48
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 243,
                            column: 10
                        },
                        end: {
                            line: 243,
                            column: 27
                        }
                    },
                    {
                        start: {
                            line: 243,
                            column: 31
                        },
                        end: {
                            line: 243,
                            column: 48
                        }
                    }
                ],
                line: 243
            },
            "34": {
                loc: {
                    start: {
                        line: 244,
                        column: 8
                    },
                    end: {
                        line: 246,
                        column: 9
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 244,
                            column: 8
                        },
                        end: {
                            line: 246,
                            column: 9
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 244
            },
            "35": {
                loc: {
                    start: {
                        line: 244,
                        column: 12
                    },
                    end: {
                        line: 244,
                        column: 50
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 244,
                            column: 12
                        },
                        end: {
                            line: 244,
                            column: 15
                        }
                    },
                    {
                        start: {
                            line: 244,
                            column: 19
                        },
                        end: {
                            line: 244,
                            column: 35
                        }
                    },
                    {
                        start: {
                            line: 244,
                            column: 39
                        },
                        end: {
                            line: 244,
                            column: 50
                        }
                    }
                ],
                line: 244
            },
            "36": {
                loc: {
                    start: {
                        line: 269,
                        column: 15
                    },
                    end: {
                        line: 304,
                        column: 18
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 269,
                            column: 15
                        },
                        end: {
                            line: 269,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 270,
                            column: 16
                        },
                        end: {
                            line: 270,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 271,
                            column: 17
                        },
                        end: {
                            line: 304,
                            column: 17
                        }
                    }
                ],
                line: 269
            },
            "37": {
                loc: {
                    start: {
                        line: 271,
                        column: 17
                    },
                    end: {
                        line: 304,
                        column: 17
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 272,
                            column: 18
                        },
                        end: {
                            line: 288,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 290,
                            column: 18
                        },
                        end: {
                            line: 303,
                            column: 20
                        }
                    }
                ],
                line: 271
            },
            "38": {
                loc: {
                    start: {
                        line: 279,
                        column: 27
                    },
                    end: {
                        line: 279,
                        column: 72
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 279,
                            column: 43
                        },
                        end: {
                            line: 279,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 279,
                            column: 59
                        },
                        end: {
                            line: 279,
                            column: 72
                        }
                    }
                ],
                line: 279
            },
            "39": {
                loc: {
                    start: {
                        line: 284,
                        column: 33
                    },
                    end: {
                        line: 284,
                        column: 79
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 284,
                            column: 55
                        },
                        end: {
                            line: 284,
                            column: 74
                        }
                    },
                    {
                        start: {
                            line: 284,
                            column: 77
                        },
                        end: {
                            line: 284,
                            column: 79
                        }
                    }
                ],
                line: 284
            },
            "40": {
                loc: {
                    start: {
                        line: 285,
                        column: 34
                    },
                    end: {
                        line: 285,
                        column: 84
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 285,
                            column: 49
                        },
                        end: {
                            line: 285,
                            column: 72
                        }
                    },
                    {
                        start: {
                            line: 285,
                            column: 75
                        },
                        end: {
                            line: 285,
                            column: 84
                        }
                    }
                ],
                line: 285
            },
            "41": {
                loc: {
                    start: {
                        line: 295,
                        column: 31
                    },
                    end: {
                        line: 295,
                        column: 81
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 295,
                            column: 46
                        },
                        end: {
                            line: 295,
                            column: 69
                        }
                    },
                    {
                        start: {
                            line: 295,
                            column: 72
                        },
                        end: {
                            line: 295,
                            column: 81
                        }
                    }
                ],
                line: 295
            },
            "42": {
                loc: {
                    start: {
                        line: 296,
                        column: 27
                    },
                    end: {
                        line: 296,
                        column: 72
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 296,
                            column: 43
                        },
                        end: {
                            line: 296,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 296,
                            column: 59
                        },
                        end: {
                            line: 296,
                            column: 72
                        }
                    }
                ],
                line: 296
            },
            "43": {
                loc: {
                    start: {
                        line: 298,
                        column: 33
                    },
                    end: {
                        line: 298,
                        column: 79
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 298,
                            column: 55
                        },
                        end: {
                            line: 298,
                            column: 74
                        }
                    },
                    {
                        start: {
                            line: 298,
                            column: 77
                        },
                        end: {
                            line: 298,
                            column: 79
                        }
                    }
                ],
                line: 298
            },
            "44": {
                loc: {
                    start: {
                        line: 305,
                        column: 15
                    },
                    end: {
                        line: 340,
                        column: 18
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 305,
                            column: 15
                        },
                        end: {
                            line: 305,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 306,
                            column: 17
                        },
                        end: {
                            line: 340,
                            column: 17
                        }
                    }
                ],
                line: 305
            },
            "45": {
                loc: {
                    start: {
                        line: 306,
                        column: 17
                    },
                    end: {
                        line: 340,
                        column: 17
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 307,
                            column: 18
                        },
                        end: {
                            line: 323,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 325,
                            column: 18
                        },
                        end: {
                            line: 339,
                            column: 20
                        }
                    }
                ],
                line: 306
            },
            "46": {
                loc: {
                    start: {
                        line: 317,
                        column: 34
                    },
                    end: {
                        line: 317,
                        column: 83
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 317,
                            column: 54
                        },
                        end: {
                            line: 317,
                            column: 71
                        }
                    },
                    {
                        start: {
                            line: 317,
                            column: 74
                        },
                        end: {
                            line: 317,
                            column: 83
                        }
                    }
                ],
                line: 317
            },
            "47": {
                loc: {
                    start: {
                        line: 330,
                        column: 31
                    },
                    end: {
                        line: 330,
                        column: 69
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 330,
                            column: 31
                        },
                        end: {
                            line: 330,
                            column: 48
                        }
                    },
                    {
                        start: {
                            line: 330,
                            column: 52
                        },
                        end: {
                            line: 330,
                            column: 69
                        }
                    }
                ],
                line: 330
            },
            "48": {
                loc: {
                    start: {
                        line: 332,
                        column: 42
                    },
                    end: {
                        line: 332,
                        column: 98
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 332,
                            column: 42
                        },
                        end: {
                            line: 332,
                            column: 61
                        }
                    },
                    {
                        start: {
                            line: 332,
                            column: 65
                        },
                        end: {
                            line: 332,
                            column: 98
                        }
                    }
                ],
                line: 332
            },
            "49": {
                loc: {
                    start: {
                        line: 341,
                        column: 15
                    },
                    end: {
                        line: 385,
                        column: 15
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 341,
                            column: 15
                        },
                        end: {
                            line: 341,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 341,
                            column: 29
                        },
                        end: {
                            line: 341,
                            column: 52
                        }
                    },
                    {
                        start: {
                            line: 342,
                            column: 16
                        },
                        end: {
                            line: 384,
                            column: 22
                        }
                    }
                ],
                line: 341
            },
            "50": {
                loc: {
                    start: {
                        line: 343,
                        column: 19
                    },
                    end: {
                        line: 369,
                        column: 19
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 344,
                            column: 20
                        },
                        end: {
                            line: 357,
                            column: 22
                        }
                    },
                    {
                        start: {
                            line: 359,
                            column: 20
                        },
                        end: {
                            line: 368,
                            column: 22
                        }
                    }
                ],
                line: 343
            },
            "51": {
                loc: {
                    start: {
                        line: 370,
                        column: 19
                    },
                    end: {
                        line: 383,
                        column: 19
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 370,
                            column: 19
                        },
                        end: {
                            line: 370,
                            column: 64
                        }
                    },
                    {
                        start: {
                            line: 371,
                            column: 20
                        },
                        end: {
                            line: 382,
                            column: 22
                        }
                    }
                ],
                line: 370
            },
            "52": {
                loc: {
                    start: {
                        line: 377,
                        column: 24
                    },
                    end: {
                        line: 379,
                        column: 25
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 377,
                            column: 24
                        },
                        end: {
                            line: 379,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 377
            },
            "53": {
                loc: {
                    start: {
                        line: 388,
                        column: 18
                    },
                    end: {
                        line: 388,
                        column: 64
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 388,
                            column: 51
                        },
                        end: {
                            line: 388,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 388,
                            column: 59
                        },
                        end: {
                            line: 388,
                            column: 64
                        }
                    }
                ],
                line: 388
            },
            "54": {
                loc: {
                    start: {
                        line: 390,
                        column: 30
                    },
                    end: {
                        line: 390,
                        column: 76
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 390,
                            column: 63
                        },
                        end: {
                            line: 390,
                            column: 69
                        }
                    },
                    {
                        start: {
                            line: 390,
                            column: 72
                        },
                        end: {
                            line: 390,
                            column: 76
                        }
                    }
                ],
                line: 390
            },
            "55": {
                loc: {
                    start: {
                        line: 393,
                        column: 30
                    },
                    end: {
                        line: 393,
                        column: 75
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 393,
                            column: 63
                        },
                        end: {
                            line: 393,
                            column: 68
                        }
                    },
                    {
                        start: {
                            line: 393,
                            column: 71
                        },
                        end: {
                            line: 393,
                            column: 75
                        }
                    }
                ],
                line: 393
            },
            "56": {
                loc: {
                    start: {
                        line: 396,
                        column: 15
                    },
                    end: {
                        line: 398,
                        column: 15
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 396,
                            column: 15
                        },
                        end: {
                            line: 396,
                            column: 45
                        }
                    },
                    {
                        start: {
                            line: 397,
                            column: 16
                        },
                        end: {
                            line: 397,
                            column: 69
                        }
                    }
                ],
                line: 396
            },
            "57": {
                loc: {
                    start: {
                        line: 416,
                        column: 9
                    },
                    end: {
                        line: 440,
                        column: 9
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 416,
                            column: 9
                        },
                        end: {
                            line: 416,
                            column: 30
                        }
                    },
                    {
                        start: {
                            line: 417,
                            column: 10
                        },
                        end: {
                            line: 439,
                            column: 16
                        }
                    }
                ],
                line: 416
            },
            "58": {
                loc: {
                    start: {
                        line: 441,
                        column: 9
                    },
                    end: {
                        line: 456,
                        column: 9
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 441,
                            column: 9
                        },
                        end: {
                            line: 441,
                            column: 39
                        }
                    },
                    {
                        start: {
                            line: 442,
                            column: 10
                        },
                        end: {
                            line: 455,
                            column: 23
                        }
                    }
                ],
                line: 441
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0,
            "64": 0,
            "65": 0,
            "66": 0,
            "67": 0,
            "68": 0,
            "69": 0,
            "70": 0,
            "71": 0,
            "72": 0,
            "73": 0,
            "74": 0,
            "75": 0,
            "76": 0,
            "77": 0,
            "78": 0,
            "79": 0,
            "80": 0,
            "81": 0,
            "82": 0,
            "83": 0,
            "84": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0
            ],
            "12": [
                0,
                0
            ],
            "13": [
                0,
                0
            ],
            "14": [
                0,
                0
            ],
            "15": [
                0,
                0
            ],
            "16": [
                0,
                0
            ],
            "17": [
                0,
                0
            ],
            "18": [
                0,
                0,
                0,
                0
            ],
            "19": [
                0,
                0
            ],
            "20": [
                0,
                0,
                0,
                0
            ],
            "21": [
                0,
                0
            ],
            "22": [
                0,
                0
            ],
            "23": [
                0,
                0
            ],
            "24": [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "25": [
                0,
                0
            ],
            "26": [
                0,
                0
            ],
            "27": [
                0,
                0
            ],
            "28": [
                0,
                0
            ],
            "29": [
                0,
                0
            ],
            "30": [
                0,
                0
            ],
            "31": [
                0,
                0
            ],
            "32": [
                0,
                0
            ],
            "33": [
                0,
                0
            ],
            "34": [
                0,
                0
            ],
            "35": [
                0,
                0,
                0
            ],
            "36": [
                0,
                0,
                0
            ],
            "37": [
                0,
                0
            ],
            "38": [
                0,
                0
            ],
            "39": [
                0,
                0
            ],
            "40": [
                0,
                0
            ],
            "41": [
                0,
                0
            ],
            "42": [
                0,
                0
            ],
            "43": [
                0,
                0
            ],
            "44": [
                0,
                0
            ],
            "45": [
                0,
                0
            ],
            "46": [
                0,
                0
            ],
            "47": [
                0,
                0
            ],
            "48": [
                0,
                0
            ],
            "49": [
                0,
                0,
                0
            ],
            "50": [
                0,
                0
            ],
            "51": [
                0,
                0
            ],
            "52": [
                0,
                0
            ],
            "53": [
                0,
                0
            ],
            "54": [
                0,
                0
            ],
            "55": [
                0,
                0
            ],
            "56": [
                0,
                0
            ],
            "57": [
                0,
                0
            ],
            "58": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "afc6a596995fb6b616ab7211278da84d16592d41"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2cjzfzrvji = function cov_2cjzfzrvji() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2cjzfzrvji();
function AccountPasswordForm_slicedToArray(r, e) {
    return AccountPasswordForm_arrayWithHoles(r) || AccountPasswordForm_iterableToArrayLimit(r, e) || AccountPasswordForm_unsupportedIterableToArray(r, e) || AccountPasswordForm_nonIterableRest();
}
function AccountPasswordForm_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AccountPasswordForm_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return AccountPasswordForm_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? AccountPasswordForm_arrayLikeToArray(r, a) : void 0;
    }
}
function AccountPasswordForm_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function AccountPasswordForm_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function AccountPasswordForm_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}


























var AccountPasswordForm = (cov_2cjzfzrvji().s[0]++, /*#__PURE__*/ (0,react.forwardRef)(function(_ref, ref) {
    var initialName = _ref.name, initialPhone = _ref.phone, onRegister = _ref.onRegister, onLogin = _ref.onLogin, hidePasswordField = _ref.hidePasswordField, isNewHuman = _ref.isNewHuman, onboardingAccountPageCTA = _ref.onboardingAccountPageCTA, passwordFormActionText = _ref.passwordFormActionText, analyticsName = _ref.analyticsName, fullNameLabel = _ref.fullNameLabel, fullNamePlaceholder = _ref.fullNamePlaceholder, loading = _ref.loading, loginError = _ref.loginError, _ref$phoneNumberInput = _ref.phoneNumberInputOptional, phoneNumberInputOptional = _ref$phoneNumberInput === void 0 ? (cov_2cjzfzrvji().b[0][0]++, true) : _ref$phoneNumberInput, _ref$phoneNumberInput2 = _ref.phoneNumberInputHidden, phoneNumberInputHidden = _ref$phoneNumberInput2 === void 0 ? (cov_2cjzfzrvji().b[1][0]++, false) : _ref$phoneNumberInput2, showPasswordlessLogin = _ref.showPasswordlessLogin, onRequestPasswordlessLogin = _ref.onRequestPasswordlessLogin, isRequestingPasswordlessLogin = _ref.isRequestingPasswordlessLogin, openForgotPasswordInNewTab = _ref.openForgotPasswordInNewTab, fullNameOptional = _ref.fullNameOptional, fullNameHidden = _ref.fullNameHidden, CustomPasswordInput = _ref.CustomPasswordInput, CustomNameInput = _ref.CustomNameInput, CustomPhoneInput = _ref.CustomPhoneInput;
    cov_2cjzfzrvji().f[0]++;
    var context = (cov_2cjzfzrvji().s[1]++, (0,react.useContext)(NamelessAccountContext));
    var _ref2 = (cov_2cjzfzrvji().s[2]++, (0,react.useState)(false)), _ref3 = AccountPasswordForm_slicedToArray(_ref2, 2), hasError = _ref3[0], setHasError = _ref3[1];
    var _ref4 = (cov_2cjzfzrvji().s[3]++, (0,react.useState)((cov_2cjzfzrvji().b[2][0]++, initialName) || (cov_2cjzfzrvji().b[2][1]++, ""))), _ref5 = AccountPasswordForm_slicedToArray(_ref4, 2), name = _ref5[0], setName = _ref5[1];
    var _ref6 = (cov_2cjzfzrvji().s[4]++, (0,react.useState)(false)), _ref7 = AccountPasswordForm_slicedToArray(_ref6, 2), hasNameError = _ref7[0], setNameError = _ref7[1];
    var _ref8 = (cov_2cjzfzrvji().s[5]++, (0,react.useState)(false)), _ref9 = AccountPasswordForm_slicedToArray(_ref8, 2), hasPasswordError = _ref9[0], setHasPasswordError = _ref9[1];
    var _ref0 = (cov_2cjzfzrvji().s[6]++, (0,react.useState)((cov_2cjzfzrvji().b[3][0]++, initialPhone) || (cov_2cjzfzrvji().b[3][1]++, ""))), _ref1 = AccountPasswordForm_slicedToArray(_ref0, 2), phone = _ref1[0], setPhone = _ref1[1];
    var _ref10 = (cov_2cjzfzrvji().s[7]++, (0,react.useState)(false)), _ref11 = AccountPasswordForm_slicedToArray(_ref10, 2), smsSubscribed = _ref11[0], setSmsSubscribed = _ref11[1];
    var _ref12 = (cov_2cjzfzrvji().s[8]++, (0,react.useState)(!phoneNumberInputOptional)), _ref13 = AccountPasswordForm_slicedToArray(_ref12, 2), hasPhoneError = _ref13[0], setPhoneError = _ref13[1];
    var _ref14 = (cov_2cjzfzrvji().s[9]++, (0,react.useState)("")), _ref15 = AccountPasswordForm_slicedToArray(_ref14, 2), password = _ref15[0], setPassword = _ref15[1];
    var _ref16 = (cov_2cjzfzrvji().s[10]++, (0,react.useState)({})), _ref17 = AccountPasswordForm_slicedToArray(_ref16, 2), lastSubmit = _ref17[0], setLastSubmit = _ref17[1];
    var getPhoneState = (cov_2cjzfzrvji().s[11]++, (0,react.useCallback)(function(phone) {
        cov_2cjzfzrvji().f[1]++;
        cov_2cjzfzrvji().s[12]++;
        if ((cov_2cjzfzrvji().b[5][0]++, isNil_default()(phone)) || (cov_2cjzfzrvji().b[5][1]++, phone === "")) {
            cov_2cjzfzrvji().b[4][0]++;
            cov_2cjzfzrvji().s[13]++;
            return {
                hasError: !phoneNumberInputOptional,
                value: phone
            };
        } else {
            cov_2cjzfzrvji().b[4][1]++;
        }
        // ValidatedTextInput with format="telephoneNumber" will handle phone validation
        // This is just for initial state - actual validation happens in the component
        cov_2cjzfzrvji().s[14]++;
        return {
            hasError: false,
            // Let ValidatedTextInput handle validation
            value: phone
        };
    }, [
        phoneNumberInputOptional
    ]));
    var maybePrefillAccount = (cov_2cjzfzrvji().s[15]++, (0,react.useCallback)(function() {
        cov_2cjzfzrvji().f[2]++;
        var url = (cov_2cjzfzrvji().s[16]++, new URL(window.location.href));
        var params = (cov_2cjzfzrvji().s[17]++, new URLSearchParams(url.searchParams));
        var phoneNumber = (cov_2cjzfzrvji().s[18]++, (cov_2cjzfzrvji().b[6][0]++, params.get("phoneNumber")) || (cov_2cjzfzrvji().b[6][1]++, initialPhone));
        var _ref18 = (cov_2cjzfzrvji().s[19]++, getPhoneState(phoneNumber)), value = _ref18.value, hasError = _ref18.hasError;
        cov_2cjzfzrvji().s[20]++;
        if ((cov_2cjzfzrvji().b[8][0]++, params.get("name")) || (cov_2cjzfzrvji().b[8][1]++, params.get("phoneNumber"))) {
            cov_2cjzfzrvji().b[7][0]++;
            cov_2cjzfzrvji().s[21]++;
            setName(params.get("name"));
            cov_2cjzfzrvji().s[22]++;
            setPhone(hasError ? (cov_2cjzfzrvji().b[9][0]++, "") : (cov_2cjzfzrvji().b[9][1]++, value));
            cov_2cjzfzrvji().s[23]++;
            setPhoneError(hasError);
        } else {
            cov_2cjzfzrvji().b[7][1]++;
        }
    }, [
        getPhoneState,
        initialPhone
    ]));
    cov_2cjzfzrvji().s[24]++;
    (0,react.useEffect)(function() {
        cov_2cjzfzrvji().f[3]++;
        cov_2cjzfzrvji().s[25]++;
        maybePrefillAccount();
        cov_2cjzfzrvji().s[26]++;
        if (context.onPasswordFormLoad) {
            cov_2cjzfzrvji().b[10][0]++;
            cov_2cjzfzrvji().s[27]++;
            context.onPasswordFormLoad();
        } else {
            cov_2cjzfzrvji().b[10][1]++;
        }
    }, [
        context,
        maybePrefillAccount
    ]);
    cov_2cjzfzrvji().s[28]++;
    var validatePasswordLength = function validatePasswordLength(password) {
        cov_2cjzfzrvji().f[4]++;
        cov_2cjzfzrvji().s[29]++;
        return (cov_2cjzfzrvji().b[11][0]++, password.length >= 5) && (cov_2cjzfzrvji().b[11][1]++, password.length <= 128);
    };
    cov_2cjzfzrvji().s[30]++;
    var onNameChange = function onNameChange(name) {
        cov_2cjzfzrvji().f[5]++;
        cov_2cjzfzrvji().s[31]++;
        setName(name);
        var isNameEmpty = (cov_2cjzfzrvji().s[32]++, (cov_2cjzfzrvji().b[12][0]++, isNil_default()(name)) || (cov_2cjzfzrvji().b[12][1]++, name === ""));
        var isNameValid = (cov_2cjzfzrvji().s[33]++, name.trim() !== "");
        cov_2cjzfzrvji().s[34]++;
        if (fullNameOptional) {
            cov_2cjzfzrvji().b[13][0]++;
            cov_2cjzfzrvji().s[35]++;
            setNameError(isNameEmpty ? (cov_2cjzfzrvji().b[14][0]++, false) : (cov_2cjzfzrvji().b[14][1]++, !isNameValid));
        } else {
            cov_2cjzfzrvji().b[13][1]++;
            cov_2cjzfzrvji().s[36]++;
            setNameError((cov_2cjzfzrvji().b[15][0]++, isNameEmpty) || (cov_2cjzfzrvji().b[15][1]++, !isNameValid));
        }
    };
    cov_2cjzfzrvji().s[37]++;
    var onPhoneChange = function onPhoneChange(phone) {
        cov_2cjzfzrvji().f[6]++;
        var _ref19 = (cov_2cjzfzrvji().s[38]++, getPhoneState(phone)), value = _ref19.value, hasError = _ref19.hasError;
        cov_2cjzfzrvji().s[39]++;
        setPhone(value);
        cov_2cjzfzrvji().s[40]++;
        setPhoneError(hasError);
    };
    cov_2cjzfzrvji().s[41]++;
    var onPasswordChange = function onPasswordChange(password) {
        cov_2cjzfzrvji().f[7]++;
        cov_2cjzfzrvji().s[42]++;
        //Password is validated only on blur
        setHasPasswordError(false);
        //This is to disable submit based on onchange validation
        cov_2cjzfzrvji().s[43]++;
        setHasError((cov_2cjzfzrvji().b[16][0]++, isNil_default()(password)) || (cov_2cjzfzrvji().b[16][1]++, !validatePasswordLength(password)));
        cov_2cjzfzrvji().s[44]++;
        setPassword(password);
    };
    cov_2cjzfzrvji().s[45]++;
    var handleSubmit = function handleSubmit(e) {
        cov_2cjzfzrvji().f[8]++;
        cov_2cjzfzrvji().s[46]++;
        e.preventDefault();
        cov_2cjzfzrvji().s[47]++;
        if ((cov_2cjzfzrvji().b[18][0]++, hasError) || (cov_2cjzfzrvji().b[18][1]++, isNewHuman) && ((cov_2cjzfzrvji().b[18][2]++, hasNameError) || (cov_2cjzfzrvji().b[18][3]++, hasPhoneError))) {
            cov_2cjzfzrvji().b[17][0]++;
            cov_2cjzfzrvji().s[48]++;
            return;
        } else {
            cov_2cjzfzrvji().b[17][1]++;
        }
        cov_2cjzfzrvji().s[49]++;
        if (// Only check to return early if there is a previous submission
        (cov_2cjzfzrvji().b[20][0]++, Object.values(lastSubmit).filter(Boolean).length !== 0) && (cov_2cjzfzrvji().b[20][1]++, name === lastSubmit.name) && (cov_2cjzfzrvji().b[20][2]++, password === lastSubmit.password) && (cov_2cjzfzrvji().b[20][3]++, phone === lastSubmit.phone)) {
            cov_2cjzfzrvji().b[19][0]++;
            cov_2cjzfzrvji().s[50]++;
            return;
        } else {
            cov_2cjzfzrvji().b[19][1]++;
        }
        cov_2cjzfzrvji().s[51]++;
        if (isNewHuman) {
            cov_2cjzfzrvji().b[21][0]++;
            cov_2cjzfzrvji().s[52]++;
            if ((cov_2cjzfzrvji().b[23][0]++, context.shouldRegisterOnEmailSubmit) && (cov_2cjzfzrvji().b[23][1]++, context.onAccountUpdate)) {
                cov_2cjzfzrvji().b[22][0]++;
                cov_2cjzfzrvji().s[53]++;
                context.onAccountUpdate(name, phone, smsSubscribed);
            } else {
                cov_2cjzfzrvji().b[22][1]++;
                cov_2cjzfzrvji().s[54]++;
                // Registering on pw page does not support SMS opt-out
                onRegister(password, name, phone);
            }
        } else {
            cov_2cjzfzrvji().b[21][1]++;
            cov_2cjzfzrvji().s[55]++;
            onLogin(password);
        }
        cov_2cjzfzrvji().s[56]++;
        setLastSubmit({
            name: name,
            password: password,
            phone: phone
        });
    };
    var shouldDisableSubmit = (cov_2cjzfzrvji().s[57]++, (cov_2cjzfzrvji().b[24][0]++, hasError) || (cov_2cjzfzrvji().b[24][1]++, !hidePasswordField) && ((cov_2cjzfzrvji().b[24][2]++, !password) || (cov_2cjzfzrvji().b[24][3]++, password.length === 0)) || (cov_2cjzfzrvji().b[24][4]++, isNewHuman) && ((cov_2cjzfzrvji().b[24][5]++, !fullNameOptional) && ((cov_2cjzfzrvji().b[24][6]++, !name) || (cov_2cjzfzrvji().b[24][7]++, hasNameError)) || (cov_2cjzfzrvji().b[24][8]++, hasPhoneError)));
    var actionText = (cov_2cjzfzrvji().s[58]++, (0,translationHelper.t)("confirm"));
    cov_2cjzfzrvji().s[59]++;
    if (phoneNumberInputHidden) {
        cov_2cjzfzrvji().b[25][0]++;
        cov_2cjzfzrvji().s[60]++;
        actionText = (0,translationHelper.t)("next");
    } else {
        cov_2cjzfzrvji().b[25][1]++;
        cov_2cjzfzrvji().s[61]++;
        if (onboardingAccountPageCTA) {
            cov_2cjzfzrvji().b[26][0]++;
            cov_2cjzfzrvji().s[62]++;
            actionText = (0,translationHelper.t)("continue");
        } else {
            cov_2cjzfzrvji().b[26][1]++;
        }
    }
    cov_2cjzfzrvji().s[63]++;
    if (passwordFormActionText) {
        cov_2cjzfzrvji().b[27][0]++;
        cov_2cjzfzrvji().s[64]++;
        actionText = passwordFormActionText;
    } else {
        cov_2cjzfzrvji().b[27][1]++;
    }
    var hasPasswordRequirementError = (cov_2cjzfzrvji().s[65]++, (cov_2cjzfzrvji().b[28][0]++, hasPasswordError) && (cov_2cjzfzrvji().b[28][1]++, isNewHuman)), showPasswordError = (cov_2cjzfzrvji().s[66]++, (cov_2cjzfzrvji().b[29][0]++, hasPasswordRequirementError) || (cov_2cjzfzrvji().b[29][1]++, loginError)), passwordErrorText = (cov_2cjzfzrvji().s[67]++, loginError ? (cov_2cjzfzrvji().b[30][0]++, loginError) : (cov_2cjzfzrvji().b[30][1]++, (0,translationHelper.t)("passwordRequirementError")));
    var shouldRenderDisclaimerAboveCTA = (cov_2cjzfzrvji().s[68]++, (cov_2cjzfzrvji().b[31][0]++, !phoneNumberInputHidden) && (cov_2cjzfzrvji().b[31][1]++, isNewHuman));
    var shouldRenderDisclaimerBelowCTA = (cov_2cjzfzrvji().s[69]++, !shouldRenderDisclaimerAboveCTA);
    cov_2cjzfzrvji().s[70]++;
    (0,react.useEffect)(function() {
        cov_2cjzfzrvji().f[9]++;
        cov_2cjzfzrvji().s[71]++;
        if ((cov_2cjzfzrvji().b[33][0]++, showPasswordError) && (cov_2cjzfzrvji().b[33][1]++, passwordErrorText)) {
            cov_2cjzfzrvji().b[32][0]++;
            cov_2cjzfzrvji().s[72]++;
            if ((cov_2cjzfzrvji().b[35][0]++, ref) && (cov_2cjzfzrvji().b[35][1]++, "current" in ref) && (cov_2cjzfzrvji().b[35][2]++, ref.current)) {
                cov_2cjzfzrvji().b[34][0]++;
                cov_2cjzfzrvji().s[73]++;
                ref.current.focus();
            } else {
                cov_2cjzfzrvji().b[34][1]++;
            }
        } else {
            cov_2cjzfzrvji().b[32][1]++;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        showPasswordError,
        passwordErrorText
    ]);
    // Handlers for custom inputs (legacy format)
    cov_2cjzfzrvji().s[74]++;
    var handleCustomNameChange = function handleCustomNameChange(_event, value, _valid) {
        cov_2cjzfzrvji().f[10]++;
        cov_2cjzfzrvji().s[75]++;
        onNameChange(value);
    };
    cov_2cjzfzrvji().s[76]++;
    var handleCustomPhoneChange = function handleCustomPhoneChange(_event, value, _valid) {
        cov_2cjzfzrvji().f[11]++;
        cov_2cjzfzrvji().s[77]++;
        onPhoneChange(value);
    };
    cov_2cjzfzrvji().s[78]++;
    var handleCustomPasswordChange = function handleCustomPasswordChange(_event, value, _valid) {
        cov_2cjzfzrvji().f[12]++;
        cov_2cjzfzrvji().s[79]++;
        onPasswordChange(value);
    };
    cov_2cjzfzrvji().s[80]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, null, /*#__PURE__*/ react.createElement(shared/* Form */.l0, {
        onSubmitCapture: handleSubmit
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        marginBottom: "$20x"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$20x"
    }, (cov_2cjzfzrvji().b[36][0]++, isNewHuman) && (cov_2cjzfzrvji().b[36][1]++, !fullNameHidden) && (cov_2cjzfzrvji().b[36][2]++, CustomNameInput ? (cov_2cjzfzrvji().b[37][0]++, /*#__PURE__*/ react.createElement(CustomNameInput, {
        analyticsName: analyticsName,
        required: !fullNameOptional,
        unboundedWidth: false,
        value: name,
        onChange: handleCustomNameChange,
        delay: 500,
        label: fullNameLabel ? (cov_2cjzfzrvji().b[38][0]++, fullNameLabel) : (cov_2cjzfzrvji().b[38][1]++, (0,translationHelper.t)("fullName")),
        type: "text",
        id: "name",
        name: "name",
        className: "od-register-name",
        placeholder: fullNamePlaceholder ? (cov_2cjzfzrvji().b[39][0]++, fullNamePlaceholder) : (cov_2cjzfzrvji().b[39][1]++, ""),
        errorMessage: hasNameError ? (cov_2cjzfzrvji().b[40][0]++, (0,translationHelper.t)("enterFullNameError")) : (cov_2cjzfzrvji().b[40][1]++, undefined),
        autoComplete: "name",
        autoFocus: true
    })) : (cov_2cjzfzrvji().b[37][1]++, /*#__PURE__*/ react.createElement(NameInput, {
        analyticsName: analyticsName,
        autoComplete: "name",
        autoFocus: true,
        errorText: hasNameError ? (cov_2cjzfzrvji().b[41][0]++, (0,translationHelper.t)("enterFullNameError")) : (cov_2cjzfzrvji().b[41][1]++, undefined),
        title: fullNameLabel ? (cov_2cjzfzrvji().b[42][0]++, fullNameLabel) : (cov_2cjzfzrvji().b[42][1]++, (0,translationHelper.t)("fullName")),
        onChangeText: onNameChange,
        placeholder: fullNamePlaceholder ? (cov_2cjzfzrvji().b[43][0]++, fullNamePlaceholder) : (cov_2cjzfzrvji().b[43][1]++, ""),
        required: !fullNameOptional,
        prefilledValue: name,
        invalidNameError: (0,translationHelper.t)("enterFullNameError"),
        size: "medium"
    }))), (cov_2cjzfzrvji().b[44][0]++, !hidePasswordField) && (cov_2cjzfzrvji().b[44][1]++, CustomPasswordInput ? (cov_2cjzfzrvji().b[45][0]++, /*#__PURE__*/ react.createElement(CustomPasswordInput, {
        analyticsName: analyticsName,
        required: true,
        unboundedWidth: false,
        value: password,
        onChange: handleCustomPasswordChange,
        delay: 500,
        label: (0,translationHelper.t)("password"),
        autoFocus: !isNewHuman,
        className: "od-register-password",
        errorMessage: showPasswordError ? (cov_2cjzfzrvji().b[46][0]++, passwordErrorText) : (cov_2cjzfzrvji().b[46][1]++, undefined),
        error: !!showPasswordError,
        id: "password",
        name: "password",
        placeholder: "",
        type: "password"
    })) : (cov_2cjzfzrvji().b[45][1]++, /*#__PURE__*/ react.createElement(AccountPasswordInput, {
        analyticsName: analyticsName,
        autoFocus: !isNewHuman,
        supportText: (0,translationHelper.t)("passwordSupportText"),
        errorText: (cov_2cjzfzrvji().b[47][0]++, showPasswordError) && (cov_2cjzfzrvji().b[47][1]++, passwordErrorText),
        onBlur: function onBlur() {
            cov_2cjzfzrvji().f[13]++;
            cov_2cjzfzrvji().s[81]++;
            setHasPasswordError((cov_2cjzfzrvji().b[48][0]++, password.length > 0) && (cov_2cjzfzrvji().b[48][1]++, !validatePasswordLength(password)));
        },
        title: (0,translationHelper.t)("password"),
        ref: ref,
        onChangeText: onPasswordChange,
        prefilledValue: password,
        size: "medium"
    }))), (cov_2cjzfzrvji().b[49][0]++, isNewHuman) && (cov_2cjzfzrvji().b[49][1]++, !phoneNumberInputHidden) && (cov_2cjzfzrvji().b[49][2]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$5x"
    }, CustomPhoneInput ? (cov_2cjzfzrvji().b[50][0]++, /*#__PURE__*/ react.createElement(CustomPhoneInput, {
        analyticsName: analyticsName,
        required: !phoneNumberInputOptional,
        unboundedWidth: false,
        value: phone,
        onChange: handleCustomPhoneChange,
        delay: 500,
        label: (0,translationHelper.t)("phoneNumber"),
        type: "tel",
        id: "phone",
        className: "od-register-phone",
        name: "phone",
        autoComplete: "tel"
    })) : (cov_2cjzfzrvji().b[50][1]++, /*#__PURE__*/ react.createElement(PhoneInput, {
        analyticsName: analyticsName,
        title: (0,translationHelper.t)("phoneNumber"),
        onChangeText: onPhoneChange,
        required: !phoneNumberInputOptional,
        prefilledValue: phone,
        invalidPhoneError: (0,translationHelper.t)("invalidPhoneError"),
        fieldRequiredError: (0,translationHelper.t)("fieldRequiredError"),
        size: "medium"
    })), (cov_2cjzfzrvji().b[51][0]++, analyticsName === "reception-fe-account-form") && (cov_2cjzfzrvji().b[51][1]++, /*#__PURE__*/ react.createElement(SimpleCheckbox/* SimpleCheckbox */.A, {
        size: "xsmall",
        label: (0,translationHelper.t)("smsOptIn"),
        value: "value",
        analyticsName: "".concat(analyticsName, "-sms-checkbox"),
        onPress: function onPress(_, checked) {
            cov_2cjzfzrvji().f[14]++;
            cov_2cjzfzrvji().s[82]++;
            if (typeof checked === "boolean") {
                cov_2cjzfzrvji().b[52][0]++;
                cov_2cjzfzrvji().s[83]++;
                setSmsSubscribed(checked);
            } else {
                cov_2cjzfzrvji().b[52][1]++;
            }
        },
        name: "marketing-opt-in"
    }))))), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        mt: shouldRenderDisclaimerAboveCTA ? (cov_2cjzfzrvji().b[53][0]++, "$0x") : (cov_2cjzfzrvji().b[53][1]++, "$4x"),
        $largerThanSM: {
            marginBottom: shouldRenderDisclaimerAboveCTA ? (cov_2cjzfzrvji().b[54][0]++, "$10x") : (cov_2cjzfzrvji().b[54][1]++, null)
        },
        $smallerThanMD: {
            marginBottom: shouldRenderDisclaimerAboveCTA ? (cov_2cjzfzrvji().b[55][0]++, "$5x") : (cov_2cjzfzrvji().b[55][1]++, null)
        }
    }, (cov_2cjzfzrvji().b[56][0]++, shouldRenderDisclaimerAboveCTA) && (cov_2cjzfzrvji().b[56][1]++, /*#__PURE__*/ react.createElement(shared/* EmailDisclaimerText */.lX, {
        analyticsName: analyticsName
    }))), /*#__PURE__*/ react.createElement(AccountFormControls, {
        actionText: actionText,
        analyticsName: analyticsName,
        loading: loading,
        showForgotPassword: !isNewHuman,
        onRequestPasswordlessLogin: onRequestPasswordlessLogin,
        isRequestingPasswordlessLogin: isRequestingPasswordlessLogin,
        disabled: shouldDisableSubmit,
        submitA11yProps: {
            "aria-label": ""
        },
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        forgotPasswordText: (0,translationHelper.t)("forgotPassword"),
        forgotPasswordAriaNewWindow: (0,translationHelper.t)("forgotPasswordAriaNewWindow"),
        forgotPasswordAriaSameWindow: (0,translationHelper.t)("forgotPasswordAriaSameWindow")
    }))), (cov_2cjzfzrvji().b[57][0]++, showPasswordlessLogin) && (cov_2cjzfzrvji().b[57][1]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        "data-testid": "passwordless-login",
        paddingTop: "$20x",
        marginBottom: "$20x",
        borderTopWidth: 1,
        borderTopColor: "$borderPrimary"
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$subheaderSmall",
        tag: "h3",
        paddingBottom: "$10x",
        textAlign: "left"
    }, (0,translationHelper.t)("passwordlessHeader")), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$bodySmall",
        tag: "h3",
        textAlign: "left",
        paddingBottom: "$20x"
    }, (0,translationHelper.t)("passwordlessDescription")), /*#__PURE__*/ react.createElement(Button/* Button */.z, {
        variant: "secondary",
        loading: isRequestingPasswordlessLogin,
        analyticsName: "".concat(analyticsName, "-email-login-link"),
        "aria-label": null,
        onPress: onRequestPasswordlessLogin,
        size: "medium",
        label: "Email login link"
    }))), (cov_2cjzfzrvji().b[58][0]++, shouldRenderDisclaimerBelowCTA) && (cov_2cjzfzrvji().b[58][1]++, /*#__PURE__*/ react.createElement(shared/* Disclaimer */.em, {
        mt: 5
    }, (0,translationHelper.t)("emailDisclaimerPrefix"), "\xa0", /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: "https://www.opendoor.com/w/privacy",
        target: "_blank",
        analyticsName: "".concat(analyticsName, "-privacy-policy"),
        "aria-label": (0,translationHelper.t)("privacyPolicyAria"),
        typography: "$bodyXsmall"
    }, (0,translationHelper.t)("privacyPolicy")), ".", /*#__PURE__*/ react.createElement("br", null), /*#__PURE__*/ react.createElement("br", null))));
}));
cov_2cjzfzrvji().s[84]++;
AccountPasswordForm.displayName = "AccountPasswordForm";
/* harmony default export */ var auth_AccountPasswordForm = (AccountPasswordForm); //# sourceMappingURL=AccountPasswordForm.mjs.map

// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/CheckEmailForm.mjs
var CheckEmailForm = __webpack_require__(321250);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/ErrorPrompt.mjs
function cov_2toe02vd4() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/ErrorPrompt.tsx";
    var hash = "72041442b3e34f54c977368f76fad762394028d3";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/ErrorPrompt.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 12,
                    column: 55
                },
                end: {
                    line: 24,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 13,
                    column: 2
                },
                end: {
                    line: 23,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 12,
                        column: 55
                    },
                    end: {
                        line: 12,
                        column: 56
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 72
                    },
                    end: {
                        line: 24,
                        column: 1
                    }
                },
                line: 12
            }
        },
        branchMap: {},
        s: {
            "0": 0,
            "1": 0
        },
        f: {
            "0": 0
        },
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "72041442b3e34f54c977368f76fad762394028d3"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2toe02vd4 = function cov_2toe02vd4() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_2toe02vd4();


/**
 * Custom ErrorPrompt component to replace legacy Bricks ErrorPrompt
 */ cov_2toe02vd4().s[0]++;
var ErrorPrompt = function ErrorPrompt(_ref) {
    var message = _ref.message;
    cov_2toe02vd4().f[0]++;
    cov_2toe02vd4().s[1]++;
    return /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        "data-testid": "error-prompt",
        tag: "span",
        typography: "$bodySmall",
        color: "$contentStateErrorDefault",
        marginTop: "$1dot5x"
    }, message);
}; //# sourceMappingURL=ErrorPrompt.mjs.map

// EXTERNAL MODULE: ./node_modules/react-google-login/dist/google-login.js
var google_login = __webpack_require__(293645);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/helpers/iconCompatibility.js




function adaptExternalIcon(IconComponent) {
    var AdaptedIcon = function(_param) {
        var _size = _param.size, size = _size === void 0 ? 24 : _size, color = _param.color, ariaLabel = _param["aria-label"], props = (0,_object_without_properties/* default */.Z)(_param, [
            "size",
            "color",
            "aria-label"
        ]);
        var tokenValue = color ? (0,cjs.getToken)(color, "color") : void 0, iconColor = tokenValue !== void 0 ? String(tokenValue) : void 0;
        return /* @__PURE__ */ (0,jsx_runtime.jsx)(IconComponent, (0,_object_spread/* default */.Z)({
            size: size,
            color: iconColor,
            "aria-label": ariaLabel
        }, props));
    };
    return AdaptedIcon.displayName = "AdaptedIcon(".concat(IconComponent.displayName || IconComponent.name || "Icon", ")"), AdaptedIcon;
}


// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability.mjs
var observability = __webpack_require__(736525);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(182110);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/GoogleIcon.mjs

function cov_cnf7eealw() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/GoogleIcon.tsx";
    var hash = "8f7bb066781cd85c6df320971a1c283d7181dce8";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/GoogleIcon.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 6,
                    column: 26
                },
                end: {
                    line: 146,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 8,
                    column: 25
                },
                end: {
                    line: 114,
                    column: 3
                }
            },
            "2": {
                start: {
                    line: 115,
                    column: 2
                },
                end: {
                    line: 145,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 6,
                        column: 26
                    },
                    end: {
                        line: 6,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 6,
                        column: 58
                    },
                    end: {
                        line: 146,
                        column: 1
                    }
                },
                line: 6
            }
        },
        branchMap: {},
        s: {
            "0": 0,
            "1": 0,
            "2": 0
        },
        f: {
            "0": 0
        },
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "8f7bb066781cd85c6df320971a1c283d7181dce8"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_cnf7eealw = function cov_cnf7eealw() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_cnf7eealw();
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


cov_cnf7eealw().s[0]++;
var GoogleIcon = function GoogleIcon(_ref) {
    var size = _ref.size;
    cov_cnf7eealw().f[0]++;
    // eslint-disable-next-line no-restricted-syntax
    var StyleContainer = (cov_cnf7eealw().s[1]++, /*#__PURE__*/ (0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
        target: "ea8fo1m0"
    } : 0)( true ? {
        name: "1vwy214",
        styles: ".gsi-material-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;-webkit-appearance:none;background-color:WHITE;background-image:none;border:1px solid #747775;-webkit-border-radius:4px;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;color:#1f1f1f;cursor:pointer;font-family:'Roboto',arial,sans-serif;font-size:14px;height:40px;letter-spacing:0.25px;outline:none;overflow:hidden;padding:0;position:relative;text-align:center;-webkit-transition:background-color 0.218s,border-color 0.218s,box-shadow 0.218s;transition:background-color 0.218s,border-color 0.218s,box-shadow 0.218s;vertical-align:middle;white-space:nowrap;width:40px;max-width:400px;min-width:min-content;}.gsi-material-button .gsi-material-button-icon{height:20px;margin-right:12px;min-width:20px;width:20px;margin:0;padding:9px;}.gsi-material-button .gsi-material-button-content-wrapper{-webkit-align-items:center;align-items:center;display:flex;-webkit-flex-direction:row;flex-direction:row;-webkit-flex-wrap:nowrap;flex-wrap:nowrap;height:100%;justify-content:space-between;position:relative;width:100%;}.gsi-material-button .gsi-material-button-contents{-webkit-flex-grow:1;flex-grow:1;font-family:'Roboto',arial,sans-serif;font-weight:500;overflow:hidden;text-overflow:ellipsis;vertical-align:top;}.gsi-material-button .gsi-material-button-state{-webkit-transition:opacity 0.218s;transition:opacity 0.218s;bottom:0;left:0;opacity:0;position:absolute;right:0;top:0;}.gsi-material-button:disabled{cursor:default;background-color:#ffffff61;border-color:#1f1f1f1f;}.gsi-material-button:disabled .gsi-material-button-contents{opacity:38%;}.gsi-material-button:disabled .gsi-material-button-icon{opacity:38%;}.gsi-material-button:not(:disabled):active .gsi-material-button-state,.gsi-material-button:not(:disabled):focus .gsi-material-button-state{background-color:#303030;opacity:12%;}.gsi-material-button:not(:disabled):hover{-webkit-box-shadow:0 1px 2px 0 rgba(60, 64, 67, 0.3),0 1px 3px 1px rgba(60, 64, 67, 0.15);box-shadow:0 1px 2px 0 rgba(60, 64, 67, 0.3),0 1px 3px 1px rgba(60, 64, 67, 0.15);}.gsi-material-button:not(:disabled):hover .gsi-material-button-state{background-color:#303030;opacity:8%;}"
    } : 0));
    cov_cnf7eealw().s[2]++;
    return /*#__PURE__*/ react.createElement(StyleContainer, null, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        className: "gsi-material-button-icon",
        height: size,
        width: size
    }, /*#__PURE__*/ react.createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            display: "block"
        }
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#EA4335",
        d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#4285F4",
        d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#FBBC05",
        d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "#34A853",
        d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: "none",
        d: "M0 0h48v48H0z"
    }))));
}; //# sourceMappingURL=GoogleIcon.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/GoogleAuth.mjs






function cov_2671cx13vl() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/GoogleAuth.tsx";
    var hash = "a1e468aa70a77088ccfee78ac06579e3f55bbdee";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/GoogleAuth.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 11,
                    column: 19
                },
                end: {
                    line: 11,
                    column: 51
                }
            },
            "1": {
                start: {
                    line: 26,
                    column: 44
                },
                end: {
                    line: 119,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 33,
                    column: 44
                },
                end: {
                    line: 33,
                    column: 92
                }
            },
            "3": {
                start: {
                    line: 34,
                    column: 42
                },
                end: {
                    line: 34,
                    column: 60
                }
            },
            "4": {
                start: {
                    line: 35,
                    column: 37
                },
                end: {
                    line: 35,
                    column: 55
                }
            },
            "5": {
                start: {
                    line: 38,
                    column: 30
                },
                end: {
                    line: 48,
                    column: 3
                }
            },
            "6": {
                start: {
                    line: 39,
                    column: 4
                },
                end: {
                    line: 47,
                    column: 6
                }
            },
            "7": {
                start: {
                    line: 50,
                    column: 32
                },
                end: {
                    line: 60,
                    column: 3
                }
            },
            "8": {
                start: {
                    line: 51,
                    column: 25
                },
                end: {
                    line: 51,
                    column: 45
                }
            },
            "9": {
                start: {
                    line: 53,
                    column: 4
                },
                end: {
                    line: 53,
                    column: 34
                }
            },
            "10": {
                start: {
                    line: 54,
                    column: 4
                },
                end: {
                    line: 54,
                    column: 31
                }
            },
            "11": {
                start: {
                    line: 56,
                    column: 4
                },
                end: {
                    line: 59,
                    column: 7
                }
            },
            "12": {
                start: {
                    line: 62,
                    column: 32
                },
                end: {
                    line: 77,
                    column: 3
                }
            },
            "13": {
                start: {
                    line: 63,
                    column: 4
                },
                end: {
                    line: 63,
                    column: 24
                }
            },
            "14": {
                start: {
                    line: 64,
                    column: 4
                },
                end: {
                    line: 64,
                    column: 27
                }
            },
            "15": {
                start: {
                    line: 66,
                    column: 4
                },
                end: {
                    line: 74,
                    column: 6
                }
            },
            "16": {
                start: {
                    line: 76,
                    column: 4
                },
                end: {
                    line: 76,
                    column: 30
                }
            },
            "17": {
                start: {
                    line: 79,
                    column: 19
                },
                end: {
                    line: 79,
                    column: 78
                }
            },
            "18": {
                start: {
                    line: 81,
                    column: 2
                },
                end: {
                    line: 118,
                    column: 4
                }
            },
            "19": {
                start: {
                    line: 90,
                    column: 12
                },
                end: {
                    line: 108,
                    column: 18
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 26,
                        column: 44
                    },
                    end: {
                        line: 26,
                        column: 45
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 6
                    },
                    end: {
                        line: 119,
                        column: 1
                    }
                },
                line: 32
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 38,
                        column: 30
                    },
                    end: {
                        line: 38,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 38,
                        column: 44
                    },
                    end: {
                        line: 48,
                        column: 3
                    }
                },
                line: 38
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 50,
                        column: 32
                    },
                    end: {
                        line: 50,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 50,
                        column: 46
                    },
                    end: {
                        line: 60,
                        column: 3
                    }
                },
                line: 50
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 62,
                        column: 32
                    },
                    end: {
                        line: 62,
                        column: 33
                    }
                },
                loc: {
                    start: {
                        line: 62,
                        column: 46
                    },
                    end: {
                        line: 77,
                        column: 3
                    }
                },
                line: 62
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 89,
                        column: 18
                    },
                    end: {
                        line: 89,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 90,
                        column: 12
                    },
                    end: {
                        line: 108,
                        column: 18
                    }
                },
                line: 90
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 30,
                        column: 2
                    },
                    end: {
                        line: 30,
                        column: 29
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 30,
                            column: 18
                        },
                        end: {
                            line: 30,
                            column: 29
                        }
                    }
                ],
                line: 30
            },
            "1": {
                loc: {
                    start: {
                        line: 31,
                        column: 2
                    },
                    end: {
                        line: 31,
                        column: 23
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 31,
                            column: 15
                        },
                        end: {
                            line: 31,
                            column: 23
                        }
                    }
                ],
                line: 31
            },
            "2": {
                loc: {
                    start: {
                        line: 79,
                        column: 19
                    },
                    end: {
                        line: 79,
                        column: 78
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 79,
                            column: 71
                        },
                        end: {
                            line: 79,
                            column: 73
                        }
                    },
                    {
                        start: {
                            line: 79,
                            column: 76
                        },
                        end: {
                            line: 79,
                            column: 78
                        }
                    }
                ],
                line: 79
            },
            "3": {
                loc: {
                    start: {
                        line: 79,
                        column: 19
                    },
                    end: {
                        line: 79,
                        column: 68
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 79,
                            column: 19
                        },
                        end: {
                            line: 79,
                            column: 42
                        }
                    },
                    {
                        start: {
                            line: 79,
                            column: 46
                        },
                        end: {
                            line: 79,
                            column: 68
                        }
                    }
                ],
                line: 79
            },
            "4": {
                loc: {
                    start: {
                        line: 93,
                        column: 23
                    },
                    end: {
                        line: 93,
                        column: 61
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 93,
                            column: 23
                        },
                        end: {
                            line: 93,
                            column: 34
                        }
                    },
                    {
                        start: {
                            line: 93,
                            column: 38
                        },
                        end: {
                            line: 93,
                            column: 61
                        }
                    }
                ],
                line: 93
            },
            "5": {
                loc: {
                    start: {
                        line: 112,
                        column: 7
                    },
                    end: {
                        line: 116,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 112,
                            column: 7
                        },
                        end: {
                            line: 112,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 113,
                            column: 8
                        },
                        end: {
                            line: 115,
                            column: 14
                        }
                    }
                ],
                line: 112
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "a1e468aa70a77088ccfee78ac06579e3f55bbdee"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_2671cx13vl = function cov_2671cx13vl() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}






cov_2671cx13vl();

function GoogleAuth_slicedToArray(r, e) {
    return GoogleAuth_arrayWithHoles(r) || GoogleAuth_iterableToArrayLimit(r, e) || GoogleAuth_unsupportedIterableToArray(r, e) || GoogleAuth_nonIterableRest();
}
function GoogleAuth_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function GoogleAuth_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return GoogleAuth_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? GoogleAuth_arrayLikeToArray(r, a) : void 0;
    }
}
function GoogleAuth_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function GoogleAuth_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function GoogleAuth_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}







var GoogleAuth_GoogleIcon = (cov_2671cx13vl().s[0]++, adaptExternalIcon(GoogleIcon));
cov_2671cx13vl().s[1]++;
var GoogleAuth = function GoogleAuth(_ref) {
    var buttonLabel = _ref.buttonLabel, clientId = _ref.clientId, onAuthed = _ref.onAuthed, _ref$buttonVariant = _ref.buttonVariant, buttonVariant = _ref$buttonVariant === void 0 ? (cov_2671cx13vl().b[0][0]++, "secondary") : _ref$buttonVariant, _ref$buttonSize = _ref.buttonSize, buttonSize = _ref$buttonSize === void 0 ? (cov_2671cx13vl().b[1][0]++, "medium") : _ref$buttonSize;
    cov_2671cx13vl().f[0]++;
    var _ref2 = (cov_2671cx13vl().s[2]++, react.useState(null)), _ref3 = GoogleAuth_slicedToArray(_ref2, 2), errorResponse = _ref3[0], setErrorResponse = _ref3[1];
    var _ref4 = (cov_2671cx13vl().s[3]++, react.useState("")), _ref5 = GoogleAuth_slicedToArray(_ref4, 2), errorMessage = _ref5[0], setErrorMessage = _ref5[1];
    var _ref6 = (cov_2671cx13vl().s[4]++, (0,observability/* useObservability */.C3)()), trackError = _ref6.trackError, trackEvent = _ref6.trackEvent;
    // Called, e.g., when user is in incognito mode or has otherwise blocked third-party cookies
    cov_2671cx13vl().s[5]++;
    var onScriptLoadFailure = function onScriptLoadFailure(response) {
        cov_2671cx13vl().f[1]++;
        cov_2671cx13vl().s[6]++;
        trackError("google-auth", new Error("script load failure"), {
            details: response.details,
            error_code: response.error
        }, {
            skipSentry: true
        });
    };
    cov_2671cx13vl().s[7]++;
    var googleResponseFailure = function googleResponseFailure(response) {
        cov_2671cx13vl().f[2]++;
        var errorMessage = (cov_2671cx13vl().s[8]++, (0,translationHelper.t)("googleAuthError"));
        cov_2671cx13vl().s[9]++;
        setErrorMessage(errorMessage);
        cov_2671cx13vl().s[10]++;
        setErrorResponse(response);
        cov_2671cx13vl().s[11]++;
        trackError("google-auth", new Error(errorMessage), {
            details: response.details,
            error_code: response.error
        });
    };
    cov_2671cx13vl().s[12]++;
    var googleResponseSuccess = function googleResponseSuccess(response) {
        cov_2671cx13vl().f[3]++;
        cov_2671cx13vl().s[13]++;
        setErrorMessage("");
        cov_2671cx13vl().s[14]++;
        setErrorResponse(null);
        cov_2671cx13vl().s[15]++;
        trackEvent("google-auth", "authed", {
            email: response.profileObj.email,
            name: response.profileObj.name
        }, {
            categoryOverride: "login"
        });
        cov_2671cx13vl().s[16]++;
        return onAuthed(response);
    };
    var iconSize = (cov_2671cx13vl().s[17]++, (cov_2671cx13vl().b[3][0]++, buttonSize === "xsmall") || (cov_2671cx13vl().b[3][1]++, buttonSize === "small") ? (cov_2671cx13vl().b[2][0]++, 20) : (cov_2671cx13vl().b[2][1]++, 24));
    cov_2671cx13vl().s[18]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ react.createElement(google_login.GoogleLogin, {
        clientId: clientId,
        onSuccess: googleResponseSuccess,
        onFailure: googleResponseFailure,
        onScriptLoadFailure: onScriptLoadFailure,
        render: function render(renderProps) {
            cov_2671cx13vl().f[4]++;
            cov_2671cx13vl().s[19]++;
            return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                position: "relative",
                width: "100%"
            }, /*#__PURE__*/ react.createElement(Button/* Button */.z, {
                analyticsName: "google-auth",
                label: (cov_2671cx13vl().b[4][0]++, buttonLabel) || (cov_2671cx13vl().b[4][1]++, (0,translationHelper.t)("continueWithGoogle")),
                size: buttonSize,
                variant: buttonVariant,
                onPress: renderProps.onClick,
                disabled: renderProps.disabled
            }), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                position: "absolute",
                left: "$12x",
                top: "50%",
                style: {
                    transform: [
                        {
                            translateY: "-50%"
                        }
                    ]
                },
                pointerEvents: "none"
            }, /*#__PURE__*/ react.createElement(GoogleAuth_GoogleIcon, {
                size: iconSize,
                "aria-label": "Google"
            })));
        }
    })), (cov_2671cx13vl().b[5][0]++, errorResponse) && (cov_2671cx13vl().b[5][1]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        paddingBottom: "$8x"
    }, /*#__PURE__*/ react.createElement(ErrorPrompt, {
        message: errorMessage
    }))));
}; //# sourceMappingURL=GoogleAuth.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/PasswordlessResultPage.mjs
function cov_1gd7bzijmr() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/PasswordlessResultPage.tsx";
    var hash = "3e1feaa463c93e454f4403e0cda65503cf97ff1b";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/PasswordlessResultPage.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 23,
                    column: 31
                },
                end: {
                    line: 60,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 28,
                    column: 2
                },
                end: {
                    line: 59,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 23,
                        column: 31
                    },
                    end: {
                        line: 23,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 35
                    },
                    end: {
                        line: 60,
                        column: 1
                    }
                },
                line: 27
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 31,
                        column: 9
                    },
                    end: {
                        line: 31,
                        column: 69
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 31,
                            column: 24
                        },
                        end: {
                            line: 31,
                            column: 43
                        }
                    },
                    {
                        start: {
                            line: 31,
                            column: 46
                        },
                        end: {
                            line: 31,
                            column: 69
                        }
                    }
                ],
                line: 31
            },
            "1": {
                loc: {
                    start: {
                        line: 34,
                        column: 9
                    },
                    end: {
                        line: 56,
                        column: 9
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 35,
                            column: 10
                        },
                        end: {
                            line: 41,
                            column: 13
                        }
                    },
                    {
                        start: {
                            line: 43,
                            column: 10
                        },
                        end: {
                            line: 55,
                            column: 13
                        }
                    }
                ],
                line: 34
            }
        },
        s: {
            "0": 0,
            "1": 0
        },
        f: {
            "0": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "3e1feaa463c93e454f4403e0cda65503cf97ff1b"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_1gd7bzijmr = function cov_1gd7bzijmr() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1gd7bzijmr();



cov_1gd7bzijmr().s[0]++;
var PasswordlessResultPage = function PasswordlessResultPage(_ref) {
    var email = _ref.email, hasSucceeded = _ref.hasSucceeded, analyticsName = _ref.analyticsName;
    cov_1gd7bzijmr().f[0]++;
    cov_1gd7bzijmr().s[1]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        width: "100%",
        py: "$36x",
        px: "$12x",
        gap: "$10x",
        $largerThanSM: {
            width: 480
        }
    }, /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "h1",
        typography: "$headerMedium"
    }, hasSucceeded ? (cov_1gd7bzijmr().b[0][0]++, (0,translationHelper.t)("checkYourEmail")) : (cov_1gd7bzijmr().b[0][1]++, (0,translationHelper.t)("somethingWentWrong"))), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "p",
        typography: "$bodySmall"
    }, hasSucceeded ? (cov_1gd7bzijmr().b[1][0]++, /*#__PURE__*/ react.createElement(react.Fragment, null, (0,translationHelper.t)("weSentEmailTo"), " ", /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        tag: "span",
        typography: "$bodySmall"
    }, email), ". ", (0,translationHelper.t)("includesSignInLink"))) : (cov_1gd7bzijmr().b[1][1]++, /*#__PURE__*/ react.createElement(react.Fragment, null, (0,translationHelper.t)("unableToSendEmail"), " ", /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        typography: "$bodySmall",
        variant: "secondary",
        href: "mailto:contact@opendoor.com",
        "aria-label": null,
        analyticsName: "".concat(analyticsName, "-passwordless-error-contact-us")
    }, "contact@opendoor.com"), " ", (0,translationHelper.t)("forSupport")))));
};
/* harmony default export */ var auth_PasswordlessResultPage = (PasswordlessResultPage); //# sourceMappingURL=PasswordlessResultPage.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/platform/auth/AccountForm.mjs


















var _excluded = [
    "analyticsName",
    "phone",
    "email",
    "name",
    "loginHeaderText",
    "registrationHeaderText",
    "loginSubHeaderText",
    "registrationSubHeaderText",
    "emailLoading",
    "passwordLoading",
    "error",
    "phoneNumberInputOptional",
    "phoneNumberInputHidden",
    "openForgotPasswordInNewTab",
    "showGoogleAuth",
    "overrideHasSubmittedEmailCheckForLogin",
    "emailMismatch",
    "customEmailValidityCheck",
    "customEmailValidityCheckDelay",
    "requestResetPassword",
    "hidePasswordField",
    "onPasswordlessLoginRequest",
    "onboardingAccountPageCTA",
    "fullNamePlaceholder",
    "fullNameLabel",
    "disclaimerProps",
    "passwordFormActionText",
    "onHumanStatusRequest",
    "onLogin",
    "onRegister",
    "postEmailCtaSection",
    "unsetContainer",
    "fullNameOptional",
    "fullNameHidden",
    "EmailInput",
    "PasswordInput",
    "NameInput",
    "PhoneInput"
];
function cov_173s6xv8tv() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountForm.tsx";
    var hash = "aabccc82c0c3725e45ac987c698fc4e23bf8ef7c";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountForm.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 25,
                    column: 25
                },
                end: {
                    line: 25,
                    column: 99
                }
            },
            "1": {
                start: {
                    line: 28,
                    column: 26
                },
                end: {
                    line: 30,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 29,
                    column: 2
                },
                end: {
                    line: 29,
                    column: 77
                }
            },
            "3": {
                start: {
                    line: 190,
                    column: 49
                },
                end: {
                    line: 525,
                    column: 1
                }
            },
            "4": {
                start: {
                    line: 231,
                    column: 28
                },
                end: {
                    line: 231,
                    column: 58
                }
            },
            "5": {
                start: {
                    line: 233,
                    column: 24
                },
                end: {
                    line: 233,
                    column: 36
                }
            },
            "6": {
                start: {
                    line: 234,
                    column: 27
                },
                end: {
                    line: 234,
                    column: 39
                }
            },
            "7": {
                start: {
                    line: 236,
                    column: 2
                },
                end: {
                    line: 241,
                    column: 9
                }
            },
            "8": {
                start: {
                    line: 237,
                    column: 4
                },
                end: {
                    line: 240,
                    column: 5
                }
            },
            "9": {
                start: {
                    line: 238,
                    column: 25
                },
                end: {
                    line: 238,
                    column: 66
                }
            },
            "10": {
                start: {
                    line: 239,
                    column: 6
                },
                end: {
                    line: 239,
                    column: 25
                }
            },
            "11": {
                start: {
                    line: 243,
                    column: 26
                },
                end: {
                    line: 243,
                    column: 55
                }
            },
            "12": {
                start: {
                    line: 247,
                    column: 38
                },
                end: {
                    line: 247,
                    column: 73
                }
            },
            "13": {
                start: {
                    line: 249,
                    column: 58
                },
                end: {
                    line: 251,
                    column: 3
                }
            },
            "14": {
                start: {
                    line: 253,
                    column: 54
                },
                end: {
                    line: 253,
                    column: 78
                }
            },
            "15": {
                start: {
                    line: 256,
                    column: 4
                },
                end: {
                    line: 256,
                    column: 28
                }
            },
            "16": {
                start: {
                    line: 259,
                    column: 4
                },
                end: {
                    line: 259,
                    column: 23
                }
            },
            "17": {
                start: {
                    line: 262,
                    column: 4
                },
                end: {
                    line: 262,
                    column: 38
                }
            },
            "18": {
                start: {
                    line: 264,
                    column: 22
                },
                end: {
                    line: 267,
                    column: 3
                }
            },
            "19": {
                start: {
                    line: 265,
                    column: 4
                },
                end: {
                    line: 265,
                    column: 33
                }
            },
            "20": {
                start: {
                    line: 266,
                    column: 4
                },
                end: {
                    line: 266,
                    column: 29
                }
            },
            "21": {
                start: {
                    line: 269,
                    column: 28
                },
                end: {
                    line: 272,
                    column: 3
                }
            },
            "22": {
                start: {
                    line: 270,
                    column: 4
                },
                end: {
                    line: 270,
                    column: 32
                }
            },
            "23": {
                start: {
                    line: 271,
                    column: 4
                },
                end: {
                    line: 271,
                    column: 68
                }
            },
            "24": {
                start: {
                    line: 274,
                    column: 25
                },
                end: {
                    line: 277,
                    column: 3
                }
            },
            "25": {
                start: {
                    line: 275,
                    column: 4
                },
                end: {
                    line: 275,
                    column: 33
                }
            },
            "26": {
                start: {
                    line: 276,
                    column: 4
                },
                end: {
                    line: 276,
                    column: 45
                }
            },
            "27": {
                start: {
                    line: 279,
                    column: 28
                },
                end: {
                    line: 288,
                    column: 3
                }
            },
            "28": {
                start: {
                    line: 281,
                    column: 6
                },
                end: {
                    line: 283,
                    column: 7
                }
            },
            "29": {
                start: {
                    line: 282,
                    column: 8
                },
                end: {
                    line: 282,
                    column: 48
                }
            },
            "30": {
                start: {
                    line: 284,
                    column: 6
                },
                end: {
                    line: 284,
                    column: 22
                }
            },
            "31": {
                start: {
                    line: 285,
                    column: 6
                },
                end: {
                    line: 285,
                    column: 20
                }
            },
            "32": {
                start: {
                    line: 290,
                    column: 41
                },
                end: {
                    line: 298,
                    column: 3
                }
            },
            "33": {
                start: {
                    line: 291,
                    column: 4
                },
                end: {
                    line: 297,
                    column: 5
                }
            },
            "34": {
                start: {
                    line: 292,
                    column: 6
                },
                end: {
                    line: 292,
                    column: 45
                }
            },
            "35": {
                start: {
                    line: 294,
                    column: 26
                },
                end: {
                    line: 294,
                    column: 65
                }
            },
            "36": {
                start: {
                    line: 295,
                    column: 6
                },
                end: {
                    line: 295,
                    column: 46
                }
            },
            "37": {
                start: {
                    line: 296,
                    column: 6
                },
                end: {
                    line: 296,
                    column: 58
                }
            },
            "38": {
                start: {
                    line: 301,
                    column: 26
                },
                end: {
                    line: 306,
                    column: 3
                }
            },
            "39": {
                start: {
                    line: 302,
                    column: 4
                },
                end: {
                    line: 302,
                    column: 24
                }
            },
            "40": {
                start: {
                    line: 303,
                    column: 4
                },
                end: {
                    line: 303,
                    column: 17
                }
            },
            "41": {
                start: {
                    line: 304,
                    column: 4
                },
                end: {
                    line: 304,
                    column: 35
                }
            },
            "42": {
                start: {
                    line: 305,
                    column: 4
                },
                end: {
                    line: 305,
                    column: 25
                }
            },
            "43": {
                start: {
                    line: 308,
                    column: 34
                },
                end: {
                    line: 314,
                    column: 3
                }
            },
            "44": {
                start: {
                    line: 309,
                    column: 4
                },
                end: {
                    line: 311,
                    column: 5
                }
            },
            "45": {
                start: {
                    line: 310,
                    column: 6
                },
                end: {
                    line: 310,
                    column: 54
                }
            },
            "46": {
                start: {
                    line: 313,
                    column: 4
                },
                end: {
                    line: 313,
                    column: 47
                }
            },
            "47": {
                start: {
                    line: 316,
                    column: 2
                },
                end: {
                    line: 326,
                    column: 9
                }
            },
            "48": {
                start: {
                    line: 317,
                    column: 4
                },
                end: {
                    line: 317,
                    column: 27
                }
            },
            "49": {
                start: {
                    line: 322,
                    column: 4
                },
                end: {
                    line: 324,
                    column: 5
                }
            },
            "50": {
                start: {
                    line: 323,
                    column: 6
                },
                end: {
                    line: 323,
                    column: 38
                }
            },
            "51": {
                start: {
                    line: 328,
                    column: 2
                },
                end: {
                    line: 331,
                    column: 53
                }
            },
            "52": {
                start: {
                    line: 329,
                    column: 4
                },
                end: {
                    line: 329,
                    column: 38
                }
            },
            "53": {
                start: {
                    line: 330,
                    column: 4
                },
                end: {
                    line: 330,
                    column: 56
                }
            },
            "54": {
                start: {
                    line: 333,
                    column: 29
                },
                end: {
                    line: 333,
                    column: 42
                }
            },
            "55": {
                start: {
                    line: 334,
                    column: 2
                },
                end: {
                    line: 346,
                    column: 4
                }
            },
            "56": {
                start: {
                    line: 336,
                    column: 6
                },
                end: {
                    line: 338,
                    column: 7
                }
            },
            "57": {
                start: {
                    line: 337,
                    column: 8
                },
                end: {
                    line: 337,
                    column: 62
                }
            },
            "58": {
                start: {
                    line: 339,
                    column: 6
                },
                end: {
                    line: 342,
                    column: 7
                }
            },
            "59": {
                start: {
                    line: 340,
                    column: 8
                },
                end: {
                    line: 340,
                    column: 42
                }
            },
            "60": {
                start: {
                    line: 341,
                    column: 8
                },
                end: {
                    line: 341,
                    column: 42
                }
            },
            "61": {
                start: {
                    line: 348,
                    column: 32
                },
                end: {
                    line: 348,
                    column: 87
                }
            },
            "62": {
                start: {
                    line: 350,
                    column: 28
                },
                end: {
                    line: 350,
                    column: 96
                }
            },
            "63": {
                start: {
                    line: 360,
                    column: 4
                },
                end: {
                    line: 365,
                    column: 21
                }
            },
            "64": {
                start: {
                    line: 367,
                    column: 2
                },
                end: {
                    line: 376,
                    column: 74
                }
            },
            "65": {
                start: {
                    line: 368,
                    column: 4
                },
                end: {
                    line: 371,
                    column: 5
                }
            },
            "66": {
                start: {
                    line: 369,
                    column: 6
                },
                end: {
                    line: 369,
                    column: 41
                }
            },
            "67": {
                start: {
                    line: 370,
                    column: 6
                },
                end: {
                    line: 370,
                    column: 13
                }
            },
            "68": {
                start: {
                    line: 373,
                    column: 4
                },
                end: {
                    line: 375,
                    column: 5
                }
            },
            "69": {
                start: {
                    line: 374,
                    column: 6
                },
                end: {
                    line: 374,
                    column: 42
                }
            },
            "70": {
                start: {
                    line: 378,
                    column: 2
                },
                end: {
                    line: 390,
                    column: 3
                }
            },
            "71": {
                start: {
                    line: 379,
                    column: 4
                },
                end: {
                    line: 389,
                    column: 6
                }
            },
            "72": {
                start: {
                    line: 392,
                    column: 2
                },
                end: {
                    line: 400,
                    column: 3
                }
            },
            "73": {
                start: {
                    line: 393,
                    column: 4
                },
                end: {
                    line: 399,
                    column: 6
                }
            },
            "74": {
                start: {
                    line: 403,
                    column: 25
                },
                end: {
                    line: 403,
                    column: 71
                }
            },
            "75": {
                start: {
                    line: 404,
                    column: 26
                },
                end: {
                    line: 404,
                    column: 28
                }
            },
            "76": {
                start: {
                    line: 405,
                    column: 2
                },
                end: {
                    line: 415,
                    column: 3
                }
            },
            "77": {
                start: {
                    line: 406,
                    column: 4
                },
                end: {
                    line: 406,
                    column: 59
                }
            },
            "78": {
                start: {
                    line: 407,
                    column: 9
                },
                end: {
                    line: 415,
                    column: 3
                }
            },
            "79": {
                start: {
                    line: 408,
                    column: 4
                },
                end: {
                    line: 414,
                    column: 5
                }
            },
            "80": {
                start: {
                    line: 409,
                    column: 6
                },
                end: {
                    line: 409,
                    column: 51
                }
            },
            "81": {
                start: {
                    line: 410,
                    column: 11
                },
                end: {
                    line: 414,
                    column: 5
                }
            },
            "82": {
                start: {
                    line: 411,
                    column: 6
                },
                end: {
                    line: 411,
                    column: 50
                }
            },
            "83": {
                start: {
                    line: 413,
                    column: 6
                },
                end: {
                    line: 413,
                    column: 55
                }
            },
            "84": {
                start: {
                    line: 416,
                    column: 19
                },
                end: {
                    line: 416,
                    column: 79
                }
            },
            "85": {
                start: {
                    line: 418,
                    column: 2
                },
                end: {
                    line: 422,
                    column: 3
                }
            },
            "86": {
                start: {
                    line: 419,
                    column: 4
                },
                end: {
                    line: 419,
                    column: 99
                }
            },
            "87": {
                start: {
                    line: 420,
                    column: 9
                },
                end: {
                    line: 422,
                    column: 3
                }
            },
            "88": {
                start: {
                    line: 421,
                    column: 4
                },
                end: {
                    line: 421,
                    column: 34
                }
            },
            "89": {
                start: {
                    line: 424,
                    column: 2
                },
                end: {
                    line: 524,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 28,
                        column: 26
                    },
                    end: {
                        line: 28,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 29,
                        column: 2
                    },
                    end: {
                        line: 29,
                        column: 77
                    }
                },
                line: 29
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 190,
                        column: 49
                    },
                    end: {
                        line: 190,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 230,
                        column: 6
                    },
                    end: {
                        line: 525,
                        column: 1
                    }
                },
                line: 230
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 236,
                        column: 12
                    },
                    end: {
                        line: 236,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 236,
                        column: 18
                    },
                    end: {
                        line: 241,
                        column: 3
                    }
                },
                line: 236
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 264,
                        column: 22
                    },
                    end: {
                        line: 264,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 264,
                        column: 44
                    },
                    end: {
                        line: 267,
                        column: 3
                    }
                },
                line: 264
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 269,
                        column: 28
                    },
                    end: {
                        line: 269,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 269,
                        column: 80
                    },
                    end: {
                        line: 272,
                        column: 3
                    }
                },
                line: 269
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 274,
                        column: 25
                    },
                    end: {
                        line: 274,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 274,
                        column: 76
                    },
                    end: {
                        line: 277,
                        column: 3
                    }
                },
                line: 274
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 280,
                        column: 4
                    },
                    end: {
                        line: 280,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 280,
                        column: 44
                    },
                    end: {
                        line: 286,
                        column: 5
                    }
                },
                line: 280
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 290,
                        column: 41
                    },
                    end: {
                        line: 290,
                        column: 42
                    }
                },
                loc: {
                    start: {
                        line: 290,
                        column: 53
                    },
                    end: {
                        line: 298,
                        column: 3
                    }
                },
                line: 290
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 301,
                        column: 26
                    },
                    end: {
                        line: 301,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 301,
                        column: 33
                    },
                    end: {
                        line: 306,
                        column: 3
                    }
                },
                line: 301
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 308,
                        column: 34
                    },
                    end: {
                        line: 308,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 308,
                        column: 95
                    },
                    end: {
                        line: 314,
                        column: 3
                    }
                },
                line: 308
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 316,
                        column: 12
                    },
                    end: {
                        line: 316,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 316,
                        column: 18
                    },
                    end: {
                        line: 326,
                        column: 3
                    }
                },
                line: 316
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 328,
                        column: 12
                    },
                    end: {
                        line: 328,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 328,
                        column: 18
                    },
                    end: {
                        line: 331,
                        column: 3
                    }
                },
                line: 328
            },
            "12": {
                name: "(anonymous_12)",
                decl: {
                    start: {
                        line: 335,
                        column: 4
                    },
                    end: {
                        line: 335,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 335,
                        column: 10
                    },
                    end: {
                        line: 343,
                        column: 5
                    }
                },
                line: 335
            },
            "13": {
                name: "(anonymous_13)",
                decl: {
                    start: {
                        line: 367,
                        column: 12
                    },
                    end: {
                        line: 367,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 367,
                        column: 18
                    },
                    end: {
                        line: 376,
                        column: 3
                    }
                },
                line: 367
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 192,
                        column: 2
                    },
                    end: {
                        line: 192,
                        column: 12
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 192,
                            column: 10
                        },
                        end: {
                            line: 192,
                            column: 12
                        }
                    }
                ],
                line: 192
            },
            "1": {
                loc: {
                    start: {
                        line: 193,
                        column: 9
                    },
                    end: {
                        line: 193,
                        column: 26
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 193,
                            column: 24
                        },
                        end: {
                            line: 193,
                            column: 26
                        }
                    }
                ],
                line: 193
            },
            "2": {
                loc: {
                    start: {
                        line: 194,
                        column: 8
                    },
                    end: {
                        line: 194,
                        column: 24
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 194,
                            column: 22
                        },
                        end: {
                            line: 194,
                            column: 24
                        }
                    }
                ],
                line: 194
            },
            "3": {
                loc: {
                    start: {
                        line: 205,
                        column: 2
                    },
                    end: {
                        line: 205,
                        column: 24
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 205,
                            column: 19
                        },
                        end: {
                            line: 205,
                            column: 24
                        }
                    }
                ],
                line: 205
            },
            "4": {
                loc: {
                    start: {
                        line: 211,
                        column: 2
                    },
                    end: {
                        line: 211,
                        column: 27
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 211,
                            column: 22
                        },
                        end: {
                            line: 211,
                            column: 27
                        }
                    }
                ],
                line: 211
            },
            "5": {
                loc: {
                    start: {
                        line: 237,
                        column: 4
                    },
                    end: {
                        line: 240,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 237,
                            column: 4
                        },
                        end: {
                            line: 240,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 237
            },
            "6": {
                loc: {
                    start: {
                        line: 281,
                        column: 6
                    },
                    end: {
                        line: 283,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 281,
                            column: 6
                        },
                        end: {
                            line: 283,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 281
            },
            "7": {
                loc: {
                    start: {
                        line: 291,
                        column: 4
                    },
                    end: {
                        line: 297,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 291,
                            column: 4
                        },
                        end: {
                            line: 297,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 291
            },
            "8": {
                loc: {
                    start: {
                        line: 309,
                        column: 4
                    },
                    end: {
                        line: 311,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 309,
                            column: 4
                        },
                        end: {
                            line: 311,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 309
            },
            "9": {
                loc: {
                    start: {
                        line: 309,
                        column: 8
                    },
                    end: {
                        line: 309,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 309,
                            column: 8
                        },
                        end: {
                            line: 309,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 309,
                            column: 25
                        },
                        end: {
                            line: 309,
                            column: 30
                        }
                    },
                    {
                        start: {
                            line: 309,
                            column: 34
                        },
                        end: {
                            line: 309,
                            column: 46
                        }
                    }
                ],
                line: 309
            },
            "10": {
                loc: {
                    start: {
                        line: 322,
                        column: 4
                    },
                    end: {
                        line: 324,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 322,
                            column: 4
                        },
                        end: {
                            line: 324,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 322
            },
            "11": {
                loc: {
                    start: {
                        line: 336,
                        column: 6
                    },
                    end: {
                        line: 338,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 336,
                            column: 6
                        },
                        end: {
                            line: 338,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 336
            },
            "12": {
                loc: {
                    start: {
                        line: 339,
                        column: 6
                    },
                    end: {
                        line: 342,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 339,
                            column: 6
                        },
                        end: {
                            line: 342,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 339
            },
            "13": {
                loc: {
                    start: {
                        line: 348,
                        column: 32
                    },
                    end: {
                        line: 348,
                        column: 87
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 348,
                            column: 32
                        },
                        end: {
                            line: 348,
                            column: 59
                        }
                    },
                    {
                        start: {
                            line: 348,
                            column: 63
                        },
                        end: {
                            line: 348,
                            column: 87
                        }
                    }
                ],
                line: 348
            },
            "14": {
                loc: {
                    start: {
                        line: 350,
                        column: 28
                    },
                    end: {
                        line: 350,
                        column: 96
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 350,
                            column: 28
                        },
                        end: {
                            line: 350,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 350,
                            column: 37
                        },
                        end: {
                            line: 350,
                            column: 53
                        }
                    },
                    {
                        start: {
                            line: 350,
                            column: 57
                        },
                        end: {
                            line: 350,
                            column: 70
                        }
                    },
                    {
                        start: {
                            line: 350,
                            column: 74
                        },
                        end: {
                            line: 350,
                            column: 96
                        }
                    }
                ],
                line: 350
            },
            "15": {
                loc: {
                    start: {
                        line: 360,
                        column: 4
                    },
                    end: {
                        line: 365,
                        column: 21
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 360,
                            column: 4
                        },
                        end: {
                            line: 360,
                            column: 14
                        }
                    },
                    {
                        start: {
                            line: 361,
                            column: 4
                        },
                        end: {
                            line: 361,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 362,
                            column: 4
                        },
                        end: {
                            line: 362,
                            column: 18
                        }
                    },
                    {
                        start: {
                            line: 363,
                            column: 4
                        },
                        end: {
                            line: 363,
                            column: 26
                        }
                    },
                    {
                        start: {
                            line: 364,
                            column: 4
                        },
                        end: {
                            line: 364,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 365,
                            column: 4
                        },
                        end: {
                            line: 365,
                            column: 21
                        }
                    }
                ],
                line: 360
            },
            "16": {
                loc: {
                    start: {
                        line: 368,
                        column: 4
                    },
                    end: {
                        line: 371,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 368,
                            column: 4
                        },
                        end: {
                            line: 371,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 368
            },
            "17": {
                loc: {
                    start: {
                        line: 373,
                        column: 4
                    },
                    end: {
                        line: 375,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 373,
                            column: 4
                        },
                        end: {
                            line: 375,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 373
            },
            "18": {
                loc: {
                    start: {
                        line: 373,
                        column: 8
                    },
                    end: {
                        line: 373,
                        column: 45
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 373,
                            column: 8
                        },
                        end: {
                            line: 373,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 373,
                            column: 29
                        },
                        end: {
                            line: 373,
                            column: 45
                        }
                    }
                ],
                line: 373
            },
            "19": {
                loc: {
                    start: {
                        line: 378,
                        column: 2
                    },
                    end: {
                        line: 390,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 378,
                            column: 2
                        },
                        end: {
                            line: 390,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 378
            },
            "20": {
                loc: {
                    start: {
                        line: 378,
                        column: 6
                    },
                    end: {
                        line: 378,
                        column: 47
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 378,
                            column: 6
                        },
                        end: {
                            line: 378,
                            column: 23
                        }
                    },
                    {
                        start: {
                            line: 378,
                            column: 27
                        },
                        end: {
                            line: 378,
                            column: 47
                        }
                    }
                ],
                line: 378
            },
            "21": {
                loc: {
                    start: {
                        line: 380,
                        column: 36
                    },
                    end: {
                        line: 380,
                        column: 65
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 380,
                            column: 53
                        },
                        end: {
                            line: 380,
                            column: 59
                        }
                    },
                    {
                        start: {
                            line: 380,
                            column: 62
                        },
                        end: {
                            line: 380,
                            column: 65
                        }
                    }
                ],
                line: 380
            },
            "22": {
                loc: {
                    start: {
                        line: 392,
                        column: 2
                    },
                    end: {
                        line: 400,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 392,
                            column: 2
                        },
                        end: {
                            line: 400,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 392
            },
            "23": {
                loc: {
                    start: {
                        line: 403,
                        column: 25
                    },
                    end: {
                        line: 403,
                        column: 71
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 403,
                            column: 25
                        },
                        end: {
                            line: 403,
                            column: 43
                        }
                    },
                    {
                        start: {
                            line: 403,
                            column: 48
                        },
                        end: {
                            line: 403,
                            column: 61
                        }
                    },
                    {
                        start: {
                            line: 403,
                            column: 65
                        },
                        end: {
                            line: 403,
                            column: 70
                        }
                    }
                ],
                line: 403
            },
            "24": {
                loc: {
                    start: {
                        line: 405,
                        column: 2
                    },
                    end: {
                        line: 415,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 405,
                            column: 2
                        },
                        end: {
                            line: 415,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: 407,
                            column: 9
                        },
                        end: {
                            line: 415,
                            column: 3
                        }
                    }
                ],
                line: 405
            },
            "25": {
                loc: {
                    start: {
                        line: 405,
                        column: 6
                    },
                    end: {
                        line: 405,
                        column: 28
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 405,
                            column: 6
                        },
                        end: {
                            line: 405,
                            column: 19
                        }
                    },
                    {
                        start: {
                            line: 405,
                            column: 23
                        },
                        end: {
                            line: 405,
                            column: 28
                        }
                    }
                ],
                line: 405
            },
            "26": {
                loc: {
                    start: {
                        line: 407,
                        column: 9
                    },
                    end: {
                        line: 415,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 407,
                            column: 9
                        },
                        end: {
                            line: 415,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 407
            },
            "27": {
                loc: {
                    start: {
                        line: 407,
                        column: 13
                    },
                    end: {
                        line: 407,
                        column: 41
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 407,
                            column: 13
                        },
                        end: {
                            line: 407,
                            column: 18
                        }
                    },
                    {
                        start: {
                            line: 407,
                            column: 22
                        },
                        end: {
                            line: 407,
                            column: 41
                        }
                    }
                ],
                line: 407
            },
            "28": {
                loc: {
                    start: {
                        line: 408,
                        column: 4
                    },
                    end: {
                        line: 414,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 408,
                            column: 4
                        },
                        end: {
                            line: 414,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 410,
                            column: 11
                        },
                        end: {
                            line: 414,
                            column: 5
                        }
                    }
                ],
                line: 408
            },
            "29": {
                loc: {
                    start: {
                        line: 410,
                        column: 11
                    },
                    end: {
                        line: 414,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 410,
                            column: 11
                        },
                        end: {
                            line: 414,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 412,
                            column: 11
                        },
                        end: {
                            line: 414,
                            column: 5
                        }
                    }
                ],
                line: 410
            },
            "30": {
                loc: {
                    start: {
                        line: 416,
                        column: 19
                    },
                    end: {
                        line: 416,
                        column: 79
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 416,
                            column: 45
                        },
                        end: {
                            line: 416,
                            column: 60
                        }
                    },
                    {
                        start: {
                            line: 416,
                            column: 63
                        },
                        end: {
                            line: 416,
                            column: 79
                        }
                    }
                ],
                line: 416
            },
            "31": {
                loc: {
                    start: {
                        line: 418,
                        column: 2
                    },
                    end: {
                        line: 422,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 418,
                            column: 2
                        },
                        end: {
                            line: 422,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: 420,
                            column: 9
                        },
                        end: {
                            line: 422,
                            column: 3
                        }
                    }
                ],
                line: 418
            },
            "32": {
                loc: {
                    start: {
                        line: 418,
                        column: 6
                    },
                    end: {
                        line: 418,
                        column: 37
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 418,
                            column: 6
                        },
                        end: {
                            line: 418,
                            column: 23
                        }
                    },
                    {
                        start: {
                            line: 418,
                            column: 27
                        },
                        end: {
                            line: 418,
                            column: 37
                        }
                    }
                ],
                line: 418
            },
            "33": {
                loc: {
                    start: {
                        line: 419,
                        column: 17
                    },
                    end: {
                        line: 419,
                        column: 98
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 419,
                            column: 50
                        },
                        end: {
                            line: 419,
                            column: 72
                        }
                    },
                    {
                        start: {
                            line: 419,
                            column: 75
                        },
                        end: {
                            line: 419,
                            column: 98
                        }
                    }
                ],
                line: 419
            },
            "34": {
                loc: {
                    start: {
                        line: 420,
                        column: 9
                    },
                    end: {
                        line: 422,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 420,
                            column: 9
                        },
                        end: {
                            line: 422,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 420
            },
            "35": {
                loc: {
                    start: {
                        line: 425,
                        column: 34
                    },
                    end: {
                        line: 425,
                        column: 89
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 425,
                            column: 51
                        },
                        end: {
                            line: 425,
                            column: 57
                        }
                    },
                    {
                        start: {
                            line: 425,
                            column: 60
                        },
                        end: {
                            line: 425,
                            column: 89
                        }
                    }
                ],
                line: 425
            },
            "36": {
                loc: {
                    start: {
                        line: 425,
                        column: 60
                    },
                    end: {
                        line: 425,
                        column: 89
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 425,
                            column: 80
                        },
                        end: {
                            line: 425,
                            column: 83
                        }
                    },
                    {
                        start: {
                            line: 425,
                            column: 86
                        },
                        end: {
                            line: 425,
                            column: 89
                        }
                    }
                ],
                line: 425
            },
            "37": {
                loc: {
                    start: {
                        line: 427,
                        column: 7
                    },
                    end: {
                        line: 427,
                        column: 72
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 427,
                            column: 7
                        },
                        end: {
                            line: 427,
                            column: 17
                        }
                    },
                    {
                        start: {
                            line: 427,
                            column: 21
                        },
                        end: {
                            line: 427,
                            column: 72
                        }
                    }
                ],
                line: 427
            },
            "38": {
                loc: {
                    start: {
                        line: 428,
                        column: 7
                    },
                    end: {
                        line: 430,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 428,
                            column: 7
                        },
                        end: {
                            line: 428,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 428,
                            column: 29
                        },
                        end: {
                            line: 428,
                            column: 67
                        }
                    },
                    {
                        start: {
                            line: 429,
                            column: 8
                        },
                        end: {
                            line: 429,
                            column: 61
                        }
                    }
                ],
                line: 428
            },
            "39": {
                loc: {
                    start: {
                        line: 441,
                        column: 7
                    },
                    end: {
                        line: 449,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 441,
                            column: 7
                        },
                        end: {
                            line: 441,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 441,
                            column: 26
                        },
                        end: {
                            line: 441,
                            column: 44
                        }
                    },
                    {
                        start: {
                            line: 441,
                            column: 48
                        },
                        end: {
                            line: 441,
                            column: 86
                        }
                    },
                    {
                        start: {
                            line: 442,
                            column: 8
                        },
                        end: {
                            line: 448,
                            column: 14
                        }
                    }
                ],
                line: 441
            },
            "40": {
                loc: {
                    start: {
                        line: 445,
                        column: 21
                    },
                    end: {
                        line: 445,
                        column: 95
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 445,
                            column: 85
                        },
                        end: {
                            line: 445,
                            column: 91
                        }
                    },
                    {
                        start: {
                            line: 445,
                            column: 94
                        },
                        end: {
                            line: 445,
                            column: 95
                        }
                    }
                ],
                line: 445
            },
            "41": {
                loc: {
                    start: {
                        line: 445,
                        column: 21
                    },
                    end: {
                        line: 445,
                        column: 82
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 445,
                            column: 21
                        },
                        end: {
                            line: 445,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 445,
                            column: 35
                        },
                        end: {
                            line: 445,
                            column: 53
                        }
                    },
                    {
                        start: {
                            line: 445,
                            column: 57
                        },
                        end: {
                            line: 445,
                            column: 82
                        }
                    }
                ],
                line: 445
            },
            "42": {
                loc: {
                    start: {
                        line: 450,
                        column: 7
                    },
                    end: {
                        line: 452,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 450,
                            column: 7
                        },
                        end: {
                            line: 450,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 451,
                            column: 8
                        },
                        end: {
                            line: 451,
                            column: 89
                        }
                    }
                ],
                line: 450
            },
            "43": {
                loc: {
                    start: {
                        line: 453,
                        column: 7
                    },
                    end: {
                        line: 471,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 453,
                            column: 7
                        },
                        end: {
                            line: 453,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 453,
                            column: 26
                        },
                        end: {
                            line: 453,
                            column: 44
                        }
                    },
                    {
                        start: {
                            line: 453,
                            column: 48
                        },
                        end: {
                            line: 453,
                            column: 86
                        }
                    },
                    {
                        start: {
                            line: 454,
                            column: 8
                        },
                        end: {
                            line: 470,
                            column: 14
                        }
                    }
                ],
                line: 453
            },
            "44": {
                loc: {
                    start: {
                        line: 473,
                        column: 9
                    },
                    end: {
                        line: 521,
                        column: 9
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 474,
                            column: 10
                        },
                        end: {
                            line: 502,
                            column: 12
                        }
                    },
                    {
                        start: {
                            line: 504,
                            column: 10
                        },
                        end: {
                            line: 520,
                            column: 16
                        }
                    }
                ],
                line: 473
            },
            "45": {
                loc: {
                    start: {
                        line: 473,
                        column: 9
                    },
                    end: {
                        line: 473,
                        column: 47
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 473,
                            column: 9
                        },
                        end: {
                            line: 473,
                            column: 26
                        }
                    },
                    {
                        start: {
                            line: 473,
                            column: 30
                        },
                        end: {
                            line: 473,
                            column: 47
                        }
                    }
                ],
                line: 473
            },
            "46": {
                loc: {
                    start: {
                        line: 487,
                        column: 35
                    },
                    end: {
                        line: 487,
                        column: 78
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 487,
                            column: 35
                        },
                        end: {
                            line: 487,
                            column: 46
                        }
                    },
                    {
                        start: {
                            line: 487,
                            column: 50
                        },
                        end: {
                            line: 487,
                            column: 78
                        }
                    }
                ],
                line: 487
            },
            "47": {
                loc: {
                    start: {
                        line: 492,
                        column: 33
                    },
                    end: {
                        line: 492,
                        column: 79
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 492,
                            column: 55
                        },
                        end: {
                            line: 492,
                            column: 74
                        }
                    },
                    {
                        start: {
                            line: 492,
                            column: 77
                        },
                        end: {
                            line: 492,
                            column: 79
                        }
                    }
                ],
                line: 492
            },
            "48": {
                loc: {
                    start: {
                        line: 493,
                        column: 27
                    },
                    end: {
                        line: 493,
                        column: 70
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 493,
                            column: 43
                        },
                        end: {
                            line: 493,
                            column: 56
                        }
                    },
                    {
                        start: {
                            line: 493,
                            column: 59
                        },
                        end: {
                            line: 493,
                            column: 70
                        }
                    }
                ],
                line: 493
            },
            "49": {
                loc: {
                    start: {
                        line: 517,
                        column: 13
                    },
                    end: {
                        line: 519,
                        column: 13
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 517,
                            column: 13
                        },
                        end: {
                            line: 517,
                            column: 51
                        }
                    },
                    {
                        start: {
                            line: 518,
                            column: 14
                        },
                        end: {
                            line: 518,
                            column: 67
                        }
                    }
                ],
                line: 517
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0,
            "64": 0,
            "65": 0,
            "66": 0,
            "67": 0,
            "68": 0,
            "69": 0,
            "70": 0,
            "71": 0,
            "72": 0,
            "73": 0,
            "74": 0,
            "75": 0,
            "76": 0,
            "77": 0,
            "78": 0,
            "79": 0,
            "80": 0,
            "81": 0,
            "82": 0,
            "83": 0,
            "84": 0,
            "85": 0,
            "86": 0,
            "87": 0,
            "88": 0,
            "89": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0
            ],
            "3": [
                0
            ],
            "4": [
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0
            ],
            "12": [
                0,
                0
            ],
            "13": [
                0,
                0
            ],
            "14": [
                0,
                0,
                0,
                0
            ],
            "15": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "16": [
                0,
                0
            ],
            "17": [
                0,
                0
            ],
            "18": [
                0,
                0
            ],
            "19": [
                0,
                0
            ],
            "20": [
                0,
                0
            ],
            "21": [
                0,
                0
            ],
            "22": [
                0,
                0
            ],
            "23": [
                0,
                0,
                0
            ],
            "24": [
                0,
                0
            ],
            "25": [
                0,
                0
            ],
            "26": [
                0,
                0
            ],
            "27": [
                0,
                0
            ],
            "28": [
                0,
                0
            ],
            "29": [
                0,
                0
            ],
            "30": [
                0,
                0
            ],
            "31": [
                0,
                0
            ],
            "32": [
                0,
                0
            ],
            "33": [
                0,
                0
            ],
            "34": [
                0,
                0
            ],
            "35": [
                0,
                0
            ],
            "36": [
                0,
                0
            ],
            "37": [
                0,
                0
            ],
            "38": [
                0,
                0,
                0
            ],
            "39": [
                0,
                0,
                0,
                0
            ],
            "40": [
                0,
                0
            ],
            "41": [
                0,
                0,
                0
            ],
            "42": [
                0,
                0
            ],
            "43": [
                0,
                0,
                0,
                0
            ],
            "44": [
                0,
                0
            ],
            "45": [
                0,
                0
            ],
            "46": [
                0,
                0
            ],
            "47": [
                0,
                0
            ],
            "48": [
                0,
                0
            ],
            "49": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "aabccc82c0c3725e45ac987c698fc4e23bf8ef7c"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_173s6xv8tv = function cov_173s6xv8tv() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_173s6xv8tv();
function _regenerator() {
    var i = function i(r, n, o, i1) {
        var c = n && (0,_instanceof/* default */.Z)(n.prototype, Generator) ? n : Generator, u = Object.create(c.prototype);
        return _regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t1) {
                        _$i = e, c = 1, u = t1;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i1), !0), u;
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var f = function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    };
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    var a = {};
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function() {
        return this;
    }), _regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e1) {
        i = 0;
    }
    _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        var o = function o(r, n) {
            _regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        };
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n1) {
        return void e(n1);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function AccountForm_slicedToArray(r, e) {
    return AccountForm_arrayWithHoles(r) || AccountForm_iterableToArrayLimit(r, e) || AccountForm_unsupportedIterableToArray(r, e) || AccountForm_nonIterableRest();
}
function AccountForm_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AccountForm_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return AccountForm_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? AccountForm_arrayLikeToArray(r, a) : void 0;
    }
}
function AccountForm_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function AccountForm_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function AccountForm_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}



function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}














var GOOGLE_CLIENT_ID = (cov_173s6xv8tv().s[0]++, "121750171886-1udhbfom8jjascfnsscaupb7n4p17csm.apps.googleusercontent.com");
// Simple Divider component to replace legacy Bricks Divider
cov_173s6xv8tv().s[1]++;
var Divider = function Divider() {
    cov_173s6xv8tv().f[0]++;
    cov_173s6xv8tv().s[2]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        height: 1,
        backgroundColor: "$borderSecondary",
        width: "100%",
        my: "$4x"
    });
};
/**
 * @deprecated Legacy interface for custom input components. Use bricks-next form components directly instead.
 * This interface is maintained for backward compatibility with Reception-FE only.
 */ /**
 * @deprecated Legacy interface for custom input component types. Use bricks-next form components directly instead.
 * This interface is maintained for backward compatibility with Reception-FE only.
 */ cov_173s6xv8tv().s[3]++;
var AccountForm = function AccountForm(_ref) {
    var analyticsName = _ref.analyticsName, _ref$phone = _ref.phone, phone = _ref$phone === void 0 ? (cov_173s6xv8tv().b[0][0]++, "") : _ref$phone, _ref$email = _ref.email, initialEmail = _ref$email === void 0 ? (cov_173s6xv8tv().b[1][0]++, "") : _ref$email, _ref$name = _ref.name, initialName = _ref$name === void 0 ? (cov_173s6xv8tv().b[2][0]++, "") : _ref$name, loginHeaderText = _ref.loginHeaderText, registrationHeaderText = _ref.registrationHeaderText, loginSubHeaderText = _ref.loginSubHeaderText, registrationSubHeaderText = _ref.registrationSubHeaderText, emailLoading = _ref.emailLoading, passwordLoading = _ref.passwordLoading, error = _ref.error, phoneNumberInputOptional = _ref.phoneNumberInputOptional, phoneNumberInputHidden = _ref.phoneNumberInputHidden, openForgotPasswordInNewTab = _ref.openForgotPasswordInNewTab, _ref$showGoogleAuth = _ref.showGoogleAuth, showGoogleAuth = _ref$showGoogleAuth === void 0 ? (cov_173s6xv8tv().b[3][0]++, false) : _ref$showGoogleAuth, overrideHasSubmittedEmailCheckForLogin = _ref.overrideHasSubmittedEmailCheckForLogin, emailMismatch = _ref.emailMismatch, customEmailValidityCheck = _ref.customEmailValidityCheck, customEmailValidityCheckDelay = _ref.customEmailValidityCheckDelay, requestResetPassword = _ref.requestResetPassword, _ref$hidePasswordFiel = _ref.hidePasswordField, hidePasswordField = _ref$hidePasswordFiel === void 0 ? (cov_173s6xv8tv().b[4][0]++, false) : _ref$hidePasswordFiel, onPasswordlessLoginRequest = _ref.onPasswordlessLoginRequest, onboardingAccountPageCTA = _ref.onboardingAccountPageCTA, fullNamePlaceholder = _ref.fullNamePlaceholder, fullNameLabel = _ref.fullNameLabel, disclaimerProps = _ref.disclaimerProps, passwordFormActionText = _ref.passwordFormActionText, onHumanStatusRequest = _ref.onHumanStatusRequest, onLogin = _ref.onLogin, onRegister = _ref.onRegister, postEmailCtaSection = _ref.postEmailCtaSection, unsetContainer = _ref.unsetContainer, fullNameOptional = _ref.fullNameOptional, fullNameHidden = _ref.fullNameHidden, EmailInput = _ref.EmailInput, PasswordInput = _ref.PasswordInput, NameInput = _ref.NameInput, PhoneInput = _ref.PhoneInput, props = _objectWithoutProperties(_ref, _excluded);
    cov_173s6xv8tv().f[1]++;
    var _ref2 = (cov_173s6xv8tv().s[4]++, (0,react.useState)(initialEmail)), _ref3 = AccountForm_slicedToArray(_ref2, 2), email = _ref3[0], setEmail = _ref3[1];
    var emailInputRef = (cov_173s6xv8tv().s[5]++, (0,react.useRef)(null));
    var passwordInputRef = (cov_173s6xv8tv().s[6]++, (0,react.useRef)(null));
    cov_173s6xv8tv().s[7]++;
    (0,react.useEffect)(function() {
        cov_173s6xv8tv().f[2]++;
        cov_173s6xv8tv().s[8]++;
        if (emailInputRef.current) {
            cov_173s6xv8tv().b[5][0]++;
            var emailInput = (cov_173s6xv8tv().s[9]++, emailInputRef.current);
            cov_173s6xv8tv().s[10]++;
            emailInput.focus();
        } else {
            cov_173s6xv8tv().b[5][1]++;
        }
    }, []);
    var _ref4 = (cov_173s6xv8tv().s[11]++, (0,react.useState)(initialName)), _ref5 = AccountForm_slicedToArray(_ref4, 2), name = _ref5[0], setName = _ref5[1];
    //Login States
    var _ref6 = (cov_173s6xv8tv().s[12]++, (0,react.useState)(props.isNewHuman)), _ref7 = AccountForm_slicedToArray(_ref6, 2), isNewHuman = _ref7[0], setIsNewHuman = _ref7[1];
    var _ref8 = (cov_173s6xv8tv().s[13]++, (0,react.useState)(props.hasGeneratedPassword)), _ref9 = AccountForm_slicedToArray(_ref8, 2), hasGeneratedPassword = _ref9[0], setHasGeneratedPassword = _ref9[1];
    var _ref0 = (cov_173s6xv8tv().s[14]++, (0,react.useState)(false)), _ref1 = AccountForm_slicedToArray(_ref0, 2), googleLoginAttempt = _ref1[0], setGoogleLoginAttempt = _ref1[1];
    var _ref10 = (cov_173s6xv8tv().s[15]++, (0,react.useState)(false)), _ref11 = AccountForm_slicedToArray(_ref10, 2), isRequestingPasswordlessLogin = _ref11[0], setIsRequestingPasswordlessLogin = _ref11[1];
    var _ref12 = (cov_173s6xv8tv().s[16]++, (0,react.useState)()), _ref13 = AccountForm_slicedToArray(_ref12, 2), hasPasswordlessLoginRequestSucceeded = _ref13[0], setHasPasswordlessLogingRequestSucceeded = _ref13[1];
    var _ref14 = (cov_173s6xv8tv().s[17]++, (0,react.useContext)(NamelessAccountContext)), shouldRegisterOnEmailSubmit = _ref14.shouldRegisterOnEmailSubmit, emailRegistrationError = _ref14.emailRegistrationError, onAccountUpdate = _ref14.onAccountUpdate;
    cov_173s6xv8tv().s[18]++;
    var handleLogin = function handleLogin(password) {
        cov_173s6xv8tv().f[3]++;
        cov_173s6xv8tv().s[19]++;
        setGoogleLoginAttempt(false);
        cov_173s6xv8tv().s[20]++;
        onLogin(email, password);
    };
    cov_173s6xv8tv().s[21]++;
    var handleGoogleLogin = /*#__PURE__*/ function() {
        var _ref15 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(googleLoginResponse) {
            return _regenerator().w(function(_context) {
                while(1)switch(_context.n){
                    case 0:
                        cov_173s6xv8tv().f[4]++;
                        cov_173s6xv8tv().s[22]++;
                        setGoogleLoginAttempt(true);
                        cov_173s6xv8tv().s[23]++;
                        onRegister(null, null, null, null, googleLoginResponse.tokenId);
                    case 1:
                        return _context.a(2);
                }
            }, _callee);
        }));
        return function handleGoogleLogin(_x) {
            return _ref15.apply(this, arguments);
        };
    }();
    cov_173s6xv8tv().s[24]++;
    var handleRegister = function handleRegister(password, name, phone) {
        cov_173s6xv8tv().f[5]++;
        cov_173s6xv8tv().s[25]++;
        setGoogleLoginAttempt(false);
        cov_173s6xv8tv().s[26]++;
        onRegister(email, name, password, phone);
    };
    var handleEmailSubmit = (cov_173s6xv8tv().s[27]++, (0,react.useCallback)(/*#__PURE__*/ function() {
        var _ref16 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(email, name) {
            return _regenerator().w(function(_context2) {
                while(1)switch(_context2.n){
                    case 0:
                        cov_173s6xv8tv().f[6]++;
                        cov_173s6xv8tv().s[28]++;
                        if (!onHumanStatusRequest) {
                            _context2.n = 2;
                            break;
                        }
                        cov_173s6xv8tv().b[6][0]++;
                        cov_173s6xv8tv().s[29]++;
                        _context2.n = 1;
                        return onHumanStatusRequest(email, name);
                    case 1:
                        _context2.n = 3;
                        break;
                    case 2:
                        cov_173s6xv8tv().b[6][1]++;
                    case 3:
                        cov_173s6xv8tv().s[30]++;
                        setEmail(email);
                        cov_173s6xv8tv().s[31]++;
                        setName(name);
                    case 4:
                        return _context2.a(2);
                }
            }, _callee2);
        }));
        return function(_x2, _x3) {
            return _ref16.apply(this, arguments);
        };
    }(), [
        onHumanStatusRequest
    ]));
    cov_173s6xv8tv().s[32]++;
    var handleRequestPasswordlessLogin = /*#__PURE__*/ function() {
        var _ref17 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var _ref18, success;
            return _regenerator().w(function(_context3) {
                while(1)switch(_context3.n){
                    case 0:
                        cov_173s6xv8tv().f[7]++;
                        cov_173s6xv8tv().s[33]++;
                        if (!onPasswordlessLoginRequest) {
                            _context3.n = 2;
                            break;
                        }
                        cov_173s6xv8tv().b[7][0]++;
                        cov_173s6xv8tv().s[34]++;
                        setIsRequestingPasswordlessLogin(true);
                        cov_173s6xv8tv().s[35]++;
                        _context3.n = 1;
                        return onPasswordlessLoginRequest(email);
                    case 1:
                        _ref18 = _context3.v;
                        success = _ref18.success;
                        cov_173s6xv8tv().s[36]++;
                        setIsRequestingPasswordlessLogin(false);
                        cov_173s6xv8tv().s[37]++;
                        setHasPasswordlessLogingRequestSucceeded(!!success);
                        _context3.n = 3;
                        break;
                    case 2:
                        cov_173s6xv8tv().b[7][1]++;
                    case 3:
                        return _context3.a(2);
                }
            }, _callee3);
        }));
        return function handleRequestPasswordlessLogin() {
            return _ref17.apply(this, arguments);
        };
    }();
    // Toggles to the email request view and allows user to change the email being used to log in
    cov_173s6xv8tv().s[38]++;
    var resetValidEmail = function resetValidEmail(e) {
        cov_173s6xv8tv().f[8]++;
        cov_173s6xv8tv().s[39]++;
        e === null || e === void 0 || e.preventDefault();
        cov_173s6xv8tv().s[40]++;
        setEmail("");
        cov_173s6xv8tv().s[41]++;
        setHasGeneratedPassword(false);
        cov_173s6xv8tv().s[42]++;
        setIsNewHuman(false);
    };
    cov_173s6xv8tv().s[43]++;
    var socialLoginErrorMessage = function socialLoginErrorMessage(provider, emailMismatch, email) {
        cov_173s6xv8tv().f[9]++;
        cov_173s6xv8tv().s[44]++;
        if ((cov_173s6xv8tv().b[9][0]++, emailMismatch) && (cov_173s6xv8tv().b[9][1]++, email) && (cov_173s6xv8tv().b[9][2]++, email !== "")) {
            cov_173s6xv8tv().b[8][0]++;
            cov_173s6xv8tv().s[45]++;
            return (0,translationHelper.t)("socialLoginEmailMismatch", {
                email: email
            });
        } else {
            cov_173s6xv8tv().b[8][1]++;
        }
        cov_173s6xv8tv().s[46]++;
        return (0,translationHelper.t)("socialLoginError", {
            provider: provider
        });
    };
    cov_173s6xv8tv().s[47]++;
    (0,react.useEffect)(function() {
        cov_173s6xv8tv().f[10]++;
        cov_173s6xv8tv().s[48]++;
        setEmail(initialEmail);
        /**
     * If an email was passed check its status so that we can know whether to show
     * the log in or sign up page
     */ cov_173s6xv8tv().s[49]++;
        if (initialEmail) {
            cov_173s6xv8tv().b[10][0]++;
            cov_173s6xv8tv().s[50]++;
            handleEmailSubmit(initialEmail);
        } else {
            cov_173s6xv8tv().b[10][1]++;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //Making sure to only call on onmount with the initial Email
    cov_173s6xv8tv().s[51]++;
    (0,react.useEffect)(function() {
        cov_173s6xv8tv().f[11]++;
        cov_173s6xv8tv().s[52]++;
        setIsNewHuman(!!props.isNewHuman);
        cov_173s6xv8tv().s[53]++;
        setHasGeneratedPassword(props.hasGeneratedPassword);
    }, [
        props.hasGeneratedPassword,
        props.isNewHuman
    ]);
    var updatingIsNewHuman = (cov_173s6xv8tv().s[54]++, (0,react.useRef)(false));
    cov_173s6xv8tv().s[55]++;
    (0,react.useEffect)(function() {
        cov_173s6xv8tv().f[12]++;
        cov_173s6xv8tv().s[56]++;
        if (props.hasGeneratedPassword !== hasGeneratedPassword) {
            cov_173s6xv8tv().b[11][0]++;
            cov_173s6xv8tv().s[57]++;
            setHasGeneratedPassword(!!props.hasGeneratedPassword);
        } else {
            cov_173s6xv8tv().b[11][1]++;
        }
        cov_173s6xv8tv().s[58]++;
        if (props.isNewHuman !== isNewHuman) {
            cov_173s6xv8tv().b[12][0]++;
            cov_173s6xv8tv().s[59]++;
            setIsNewHuman(!!props.isNewHuman);
            cov_173s6xv8tv().s[60]++;
            updatingIsNewHuman.current = true;
        } else {
            cov_173s6xv8tv().b[12][1]++;
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        initialEmail,
        props.hasGeneratedPassword,
        props.isNewHuman
    ]);
    var hasEmailRegisterError = (cov_173s6xv8tv().s[61]++, (cov_173s6xv8tv().b[13][0]++, shouldRegisterOnEmailSubmit) && (cov_173s6xv8tv().b[13][1]++, !!emailRegistrationError));
    var hasSubmittedEmail = (cov_173s6xv8tv().s[62]++, (cov_173s6xv8tv().b[14][0]++, email) && (cov_173s6xv8tv().b[14][1]++, email.length > 0) && (cov_173s6xv8tv().b[14][2]++, !emailLoading) && (cov_173s6xv8tv().b[14][3]++, !hasEmailRegisterError));
    // This logic allows skipping the password page in cases where an onAccountUpdate method is configured
    // using the NamelessAccountContext, all password page fields are hidden, and the account is for a new
    // human. Due to the way the isNewHuman state is maintained, an additional check must be performed to
    // make sure we don't invoke the callback before the state in this component is updated after the email
    // is entered and onHumanStatusRequest is invoked to actually update the isNewHuman state via a prop.
    // Note that we are not using onRegister because onRegister requires a password, and thus we wouldn't
    // be skipping the password page.
    var skipPasswordPage = (cov_173s6xv8tv().s[63]++, (cov_173s6xv8tv().b[15][0]++, isNewHuman) && (cov_173s6xv8tv().b[15][1]++, hidePasswordField) && (cov_173s6xv8tv().b[15][2]++, fullNameHidden) && (cov_173s6xv8tv().b[15][3]++, phoneNumberInputHidden) && (cov_173s6xv8tv().b[15][4]++, shouldRegisterOnEmailSubmit) && (cov_173s6xv8tv().b[15][5]++, !!onAccountUpdate));
    cov_173s6xv8tv().s[64]++;
    (0,react.useEffect)(function() {
        cov_173s6xv8tv().f[13]++;
        cov_173s6xv8tv().s[65]++;
        if (updatingIsNewHuman.current) {
            cov_173s6xv8tv().b[16][0]++;
            cov_173s6xv8tv().s[66]++;
            updatingIsNewHuman.current = false;
            cov_173s6xv8tv().s[67]++;
            return;
        } else {
            cov_173s6xv8tv().b[16][1]++;
        }
        cov_173s6xv8tv().s[68]++;
        if ((cov_173s6xv8tv().b[18][0]++, hasSubmittedEmail) && (cov_173s6xv8tv().b[18][1]++, skipPasswordPage)) {
            cov_173s6xv8tv().b[17][0]++;
            cov_173s6xv8tv().s[69]++;
            onAccountUpdate(name, phone, false);
        } else {
            cov_173s6xv8tv().b[17][1]++;
        }
    }, [
        hasSubmittedEmail,
        name,
        onAccountUpdate,
        phone,
        skipPasswordPage
    ]);
    cov_173s6xv8tv().s[70]++;
    if ((cov_173s6xv8tv().b[20][0]++, hasSubmittedEmail) && (cov_173s6xv8tv().b[20][1]++, hasGeneratedPassword)) {
        cov_173s6xv8tv().b[19][0]++;
        cov_173s6xv8tv().s[71]++;
        return /*#__PURE__*/ react.createElement(shared/* AccountFormWrapper */.OR, {
            maxWidth: unsetContainer ? (cov_173s6xv8tv().b[21][0]++, "100%") : (cov_173s6xv8tv().b[21][1]++, 480)
        }, /*#__PURE__*/ react.createElement(CheckEmailForm/* default */.Z, {
            analyticsName: analyticsName,
            email: email,
            hasGeneratedPassword: hasGeneratedPassword,
            onResetValidEmail: resetValidEmail,
            requestResetPassword: requestResetPassword
        }));
    } else {
        cov_173s6xv8tv().b[19][1]++;
    }
    cov_173s6xv8tv().s[72]++;
    if (hasPasswordlessLoginRequestSucceeded !== undefined) {
        cov_173s6xv8tv().b[22][0]++;
        cov_173s6xv8tv().s[73]++;
        return /*#__PURE__*/ react.createElement(auth_PasswordlessResultPage, {
            hasSucceeded: hasPasswordlessLoginRequestSucceeded,
            email: email,
            analyticsName: analyticsName
        });
    } else {
        cov_173s6xv8tv().b[22][1]++;
    }
    // TODO: Clean up error handling
    var hasGoogleError = (cov_173s6xv8tv().s[74]++, (cov_173s6xv8tv().b[23][0]++, googleLoginAttempt) && ((cov_173s6xv8tv().b[23][1]++, emailMismatch) || (cov_173s6xv8tv().b[23][2]++, error)));
    var loginErrorMessage = (cov_173s6xv8tv().s[75]++, "");
    cov_173s6xv8tv().s[76]++;
    if ((cov_173s6xv8tv().b[25][0]++, emailMismatch) && (cov_173s6xv8tv().b[25][1]++, email)) {
        cov_173s6xv8tv().b[24][0]++;
        cov_173s6xv8tv().s[77]++;
        loginErrorMessage = (0,translationHelper.t)("emailMismatchError", {
            email: email
        });
    } else {
        cov_173s6xv8tv().b[24][1]++;
        cov_173s6xv8tv().s[78]++;
        if ((cov_173s6xv8tv().b[27][0]++, error) && (cov_173s6xv8tv().b[27][1]++, !googleLoginAttempt)) {
            cov_173s6xv8tv().b[26][0]++;
            cov_173s6xv8tv().s[79]++;
            if (error.includes("You have one more attempt before your account is locked.")) {
                cov_173s6xv8tv().b[28][0]++;
                cov_173s6xv8tv().s[80]++;
                loginErrorMessage = (0,translationHelper.t)("oneMoreAttemptError");
            } else {
                cov_173s6xv8tv().b[28][1]++;
                cov_173s6xv8tv().s[81]++;
                if (error.includes("Your account is locked.")) {
                    cov_173s6xv8tv().b[29][0]++;
                    cov_173s6xv8tv().s[82]++;
                    loginErrorMessage = (0,translationHelper.t)("accountLockedError");
                } else {
                    cov_173s6xv8tv().b[29][1]++;
                    cov_173s6xv8tv().s[83]++;
                    loginErrorMessage = (0,translationHelper.t)("invalidCredentialsError");
                }
            }
        } else {
            cov_173s6xv8tv().b[26][1]++;
        }
    }
    var headerText = (cov_173s6xv8tv().s[84]++, loginHeaderText != null ? (cov_173s6xv8tv().b[30][0]++, loginHeaderText) : (cov_173s6xv8tv().b[30][1]++, (0,translationHelper.t)("loginHeader")));
    cov_173s6xv8tv().s[85]++;
    if ((cov_173s6xv8tv().b[32][0]++, hasSubmittedEmail) && (cov_173s6xv8tv().b[32][1]++, isNewHuman)) {
        cov_173s6xv8tv().b[31][0]++;
        cov_173s6xv8tv().s[86]++;
        headerText = registrationHeaderText != null ? (cov_173s6xv8tv().b[33][0]++, registrationHeaderText) : (cov_173s6xv8tv().b[33][1]++, (0,translationHelper.t)("registrationHeader"));
    } else {
        cov_173s6xv8tv().b[31][1]++;
        cov_173s6xv8tv().s[87]++;
        if (hasSubmittedEmail) {
            cov_173s6xv8tv().b[34][0]++;
            cov_173s6xv8tv().s[88]++;
            headerText = (0,translationHelper.t)("welcomeBack");
        } else {
            cov_173s6xv8tv().b[34][1]++;
        }
    }
    cov_173s6xv8tv().s[89]++;
    return /*#__PURE__*/ react.createElement(shared/* AccountFormWrapper */.OR, {
        maxWidth: unsetContainer ? (cov_173s6xv8tv().b[35][0]++, "100%") : (cov_173s6xv8tv().b[35][1]++, hasSubmittedEmail ? (cov_173s6xv8tv().b[36][0]++, 560) : (cov_173s6xv8tv().b[36][1]++, 480))
    }, (cov_173s6xv8tv().b[37][0]++, headerText) && (cov_173s6xv8tv().b[37][1]++, /*#__PURE__*/ react.createElement(shared/* AccountFormHeader */.N4, null, headerText)), (cov_173s6xv8tv().b[38][0]++, !hasSubmittedEmail) && (cov_173s6xv8tv().b[38][1]++, (disclaimerProps === null || disclaimerProps === void 0 ? void 0 : disclaimerProps.location) !== "bottom") && (cov_173s6xv8tv().b[38][2]++, /*#__PURE__*/ react.createElement(shared/* EmailDisclaimerText */.lX, {
        analyticsName: analyticsName
    })), /*#__PURE__*/ react.createElement(auth_AccountFormSubHeader, {
        isNewHuman: isNewHuman,
        email: email,
        hasSubmittedEmail: hasSubmittedEmail,
        loginSubHeaderText: loginSubHeaderText,
        registrationSubHeaderText: registrationSubHeaderText,
        onValidEmailReset: resetValidEmail,
        hidePasswordField: hidePasswordField,
        phoneNumberInputHidden: phoneNumberInputHidden
    }), (cov_173s6xv8tv().b[39][0]++, showGoogleAuth) && ((cov_173s6xv8tv().b[39][1]++, !hasSubmittedEmail) || (cov_173s6xv8tv().b[39][2]++, overrideHasSubmittedEmailCheckForLogin)) && (cov_173s6xv8tv().b[39][3]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        justifyContent: "center",
        alignItems: "center",
        marginTop: (cov_173s6xv8tv().b[41][0]++, headerText) || (cov_173s6xv8tv().b[41][1]++, loginSubHeaderText) || (cov_173s6xv8tv().b[41][2]++, registrationSubHeaderText) ? (cov_173s6xv8tv().b[40][0]++, "$20x") : (cov_173s6xv8tv().b[40][1]++, 0)
    }, /*#__PURE__*/ react.createElement(GoogleAuth, {
        onAuthed: handleGoogleLogin,
        clientId: GOOGLE_CLIENT_ID
    }))), (cov_173s6xv8tv().b[42][0]++, hasGoogleError) && (cov_173s6xv8tv().b[42][1]++, /*#__PURE__*/ react.createElement(ErrorPrompt, {
        message: socialLoginErrorMessage("Google", emailMismatch, email)
    })), (cov_173s6xv8tv().b[43][0]++, showGoogleAuth) && ((cov_173s6xv8tv().b[43][1]++, !hasSubmittedEmail) || (cov_173s6xv8tv().b[43][2]++, overrideHasSubmittedEmailCheckForLogin)) && (cov_173s6xv8tv().b[43][3]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$4x",
        marginTop: "$20x",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row"
    }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flex: 1
    }, /*#__PURE__*/ react.createElement(Divider, null)), /*#__PURE__*/ react.createElement(Text/* Text */.x, {
        typography: "$bodyMedium",
        tag: "p",
        color: "$contentTertiary",
        paddingHorizontal: 7
    }, "or"), /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        flex: 1
    }, /*#__PURE__*/ react.createElement(Divider, null)))), /*#__PURE__*/ react.createElement(shared/* FormWrapper */.n5, {
        marginTop: "$20x"
    }, (cov_173s6xv8tv().b[45][0]++, hasSubmittedEmail) && (cov_173s6xv8tv().b[45][1]++, !skipPasswordPage) ? (cov_173s6xv8tv().b[44][0]++, /*#__PURE__*/ react.createElement(auth_AccountPasswordForm, {
        analyticsName: analyticsName,
        email: email,
        name: name,
        phone: phone,
        loading: passwordLoading,
        isNewHuman: isNewHuman,
        loginError: loginErrorMessage,
        onLogin: handleLogin,
        onRegister: handleRegister,
        phoneNumberInputOptional: phoneNumberInputOptional,
        phoneNumberInputHidden: phoneNumberInputHidden,
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        showPasswordlessLogin: (cov_173s6xv8tv().b[46][0]++, !isNewHuman) && (cov_173s6xv8tv().b[46][1]++, !!onPasswordlessLoginRequest),
        onRequestPasswordlessLogin: handleRequestPasswordlessLogin,
        isRequestingPasswordlessLogin: isRequestingPasswordlessLogin,
        hidePasswordField: hidePasswordField,
        onboardingAccountPageCTA: onboardingAccountPageCTA,
        fullNamePlaceholder: fullNamePlaceholder ? (cov_173s6xv8tv().b[47][0]++, fullNamePlaceholder) : (cov_173s6xv8tv().b[47][1]++, ""),
        fullNameLabel: fullNameLabel ? (cov_173s6xv8tv().b[48][0]++, fullNameLabel) : (cov_173s6xv8tv().b[48][1]++, "Full name"),
        disclaimerProps: disclaimerProps,
        ref: passwordInputRef,
        passwordFormActionText: passwordFormActionText,
        fullNameOptional: fullNameOptional,
        fullNameHidden: fullNameHidden,
        CustomPasswordInput: PasswordInput,
        CustomNameInput: NameInput,
        CustomPhoneInput: PhoneInput
    })) : (cov_173s6xv8tv().b[44][1]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        gap: "$12x"
    }, /*#__PURE__*/ react.createElement(auth_AccountEmailForm, {
        analyticsName: analyticsName,
        email: email,
        ref: emailInputRef,
        loading: emailLoading,
        onSubmit: handleEmailSubmit,
        openForgotPasswordInNewTab: openForgotPasswordInNewTab,
        customEmailValidityCheck: customEmailValidityCheck,
        customEmailValidityCheckDelay: customEmailValidityCheckDelay,
        showForgotPassword: !hidePasswordField,
        CustomEmailInput: EmailInput
    }), (cov_173s6xv8tv().b[49][0]++, (disclaimerProps === null || disclaimerProps === void 0 ? void 0 : disclaimerProps.location) === "bottom") && (cov_173s6xv8tv().b[49][1]++, /*#__PURE__*/ react.createElement(shared/* EmailDisclaimerText */.lX, {
        analyticsName: analyticsName
    }))))));
};
/* harmony default export */ var auth_AccountForm = (AccountForm); //# sourceMappingURL=AccountForm.mjs.map


/***/ }),

/***/ 293645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(667294)):0}("undefined"!=typeof self?self:this,(function(e){return o={},t.m=n=[function(t){t.exports=e},function(e,t,n){e.exports=n(2)()},function(e,t,n){"use strict";function o(){}function r(){}var i=n(3);r.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,r,a){if(a!==i){var c=Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function t(){return e}var n={array:e.isRequired=e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:r,resetWarningCache:o};return n.PropTypes=n}},function(e){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";function o(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return r(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function r(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function i(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return a(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?a(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function a(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function c(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return u(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?u(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function u(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function l(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e}finally{try{o||null==c.return||c.return()}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return s(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return"Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?s(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function s(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function f(e,t,n,o,r,i){var a=e.getElementsByTagName(t)[0],c=a,u=a;(u=e.createElement(t)).id=n,u.src=o,c&&c.parentNode?c.parentNode.insertBefore(u,c):e.head.appendChild(u),u.onerror=i,u.onload=r}function d(e,t){var n=e.getElementById(t);n&&n.parentNode.removeChild(n)}function p(e){return b.a.createElement("span",{style:{paddingRight:10,fontWeight:500,paddingLeft:e.icon?0:10,paddingTop:10,paddingBottom:10}},e.children)}function g(e){return b.a.createElement("div",{style:{marginRight:10,background:e.active?"#eee":"#fff",padding:10,borderRadius:2}},b.a.createElement("svg",{width:"18",height:"18",xmlns:"http://www.w3.org/2000/svg"},b.a.createElement("g",{fill:"#000",fillRule:"evenodd"},b.a.createElement("path",{d:"M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z",fill:"#EA4335"}),b.a.createElement("path",{d:"M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z",fill:"#4285F4"}),b.a.createElement("path",{d:"M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z",fill:"#FBBC05"}),b.a.createElement("path",{d:"M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z",fill:"#34A853"}),b.a.createElement("path",{fill:"none",d:"M0 0h18v18H0z"}))))}function y(e){var t=i(Object(m.useState)(!1),2),n=t[0],o=t[1],r=i(Object(m.useState)(!1),2),a=r[0],c=r[1],u=e.tag,l=e.type,s=e.className,f=e.disabledStyle,d=e.buttonText,y=e.children,v=e.render,S=e.theme,j=e.icon,O=e.disabled,x=h({onSuccess:e.onSuccess,onAutoLoadFinished:e.onAutoLoadFinished,onRequest:e.onRequest,onFailure:e.onFailure,onScriptLoadFailure:e.onScriptLoadFailure,clientId:e.clientId,cookiePolicy:e.cookiePolicy,loginHint:e.loginHint,hostedDomain:e.hostedDomain,autoLoad:e.autoLoad,isSignedIn:e.isSignedIn,fetchBasicProfile:e.fetchBasicProfile,redirectUri:e.redirectUri,discoveryDocs:e.discoveryDocs,uxMode:e.uxMode,scope:e.scope,accessType:e.accessType,responseType:e.responseType,jsSrc:e.jsSrc,prompt:e.prompt}),I=x.signIn,w=O||!x.loaded;if(v)return v({onClick:I,disabled:w});var k={backgroundColor:"dark"===S?"rgb(66, 133, 244)":"#fff",display:"inline-flex",alignItems:"center",color:"dark"===S?"#fff":"rgba(0, 0, 0, .54)",boxShadow:"0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)",padding:0,borderRadius:2,border:"1px solid transparent",fontSize:14,fontWeight:"500",fontFamily:"Roboto, sans-serif"},A={cursor:"pointer",backgroundColor:"dark"===S?"#3367D6":"#eee",color:"dark"===S?"#fff":"rgba(0, 0, 0, .54)",opacity:1},_=w?Object.assign({},k,f):a?Object.assign({},k,A):n?Object.assign({},k,{cursor:"pointer",opacity:.9}):k;return b.a.createElement(u,{onMouseEnter:function(){return o(!0)},onMouseLeave:function(){o(!1),c(!1)},onMouseDown:function(){return c(!0)},onMouseUp:function(){return c(!1)},onClick:I,style:_,type:l,disabled:w,className:s},[j&&b.a.createElement(g,{key:1,active:a}),b.a.createElement(p,{icon:j,key:2},y||d)])}n.r(t),n.d(t,"default",(function(){return S})),n.d(t,"GoogleLogin",(function(){return S})),n.d(t,"GoogleLogout",(function(){return O})),n.d(t,"useGoogleLogin",(function(){return h})),n.d(t,"useGoogleLogout",(function(){return j}));var m=n(0),b=n.n(m),h=(n(1),function(e){function t(e){var t=e.getBasicProfile(),n=e.getAuthResponse(!0);e.googleId=t.getId(),e.tokenObj=n,e.tokenId=n.id_token,e.accessToken=n.access_token,e.profileObj={googleId:t.getId(),imageUrl:t.getImageUrl(),email:t.getEmail(),name:t.getName(),givenName:t.getGivenName(),familyName:t.getFamilyName()},i(e)}function n(e){if(e&&e.preventDefault(),P){var n=window.gapi.auth2.getAuthInstance(),o={prompt:L};p(),"code"===_?n.grantOfflineAccess(o).then((function(e){return i(e)}),(function(e){return l(e)})):n.signIn(o).then((function(e){return t(e)}),(function(e){return l(e)}))}}var r=e.onSuccess,i=void 0===r?function(){}:r,a=e.onAutoLoadFinished,c=void 0===a?function(){}:a,u=e.onFailure,l=void 0===u?function(){}:u,s=e.onRequest,p=void 0===s?function(){}:s,g=e.onScriptLoadFailure,y=e.clientId,b=e.cookiePolicy,h=e.loginHint,v=e.hostedDomain,S=e.autoLoad,j=e.isSignedIn,O=e.fetchBasicProfile,x=e.redirectUri,I=e.discoveryDocs,w=e.uxMode,k=e.scope,A=e.accessType,_=e.responseType,E=e.jsSrc,T=void 0===E?"https://apis.google.com/js/api.js":E,L=e.prompt,M=o(Object(m.useState)(!1),2),P=M[0],C=M[1];return Object(m.useEffect)((function(){var e=!1,n=g||l;return f(document,"script","google-login",T,(function(){var o={client_id:y,cookie_policy:b,login_hint:h,hosted_domain:v,fetch_basic_profile:O,discoveryDocs:I,ux_mode:w,redirect_uri:x,scope:k,access_type:A};"code"===_&&(o.access_type="offline"),window.gapi.load("auth2",(function(){var r=window.gapi.auth2.getAuthInstance();r?r.then((function(){e||(j&&r.isSignedIn.get()?(C(!0),c(!0),t(r.currentUser.get())):(C(!0),c(!1)))}),(function(e){l(e)})):window.gapi.auth2.init(o).then((function(n){if(!e){C(!0);var o=j&&n.isSignedIn.get();c(o),o&&t(n.currentUser.get())}}),(function(e){C(!0),c(!1),n(e)}))}))}),(function(e){n(e)})),function(){e=!0,d(document,"google-login")}}),[]),Object(m.useEffect)((function(){S&&n()}),[P]),{signIn:n,loaded:P}});function v(e){var t=l(Object(m.useState)(!1),2),n=t[0],o=t[1],r=l(Object(m.useState)(!1),2),i=r[0],a=r[1],c=e.tag,u=e.type,s=e.className,f=e.disabledStyle,d=e.buttonText,y=e.children,h=e.render,v=e.theme,S=e.icon,O=e.disabled,x=j({jsSrc:e.jsSrc,onFailure:e.onFailure,onScriptLoadFailure:e.onScriptLoadFailure,clientId:e.clientId,cookiePolicy:e.cookiePolicy,loginHint:e.loginHint,hostedDomain:e.hostedDomain,fetchBasicProfile:e.fetchBasicProfile,discoveryDocs:e.discoveryDocs,uxMode:e.uxMode,redirectUri:e.redirectUri,scope:e.scope,accessType:e.accessType,onLogoutSuccess:e.onLogoutSuccess}),I=x.signOut,w=O||!x.loaded;if(h)return h({onClick:I,disabled:w});var k={backgroundColor:"dark"===v?"rgb(66, 133, 244)":"#fff",display:"inline-flex",alignItems:"center",color:"dark"===v?"#fff":"rgba(0, 0, 0, .54)",boxShadow:"0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)",padding:0,borderRadius:2,border:"1px solid transparent",fontSize:14,fontWeight:"500",fontFamily:"Roboto, sans-serif"},A={cursor:"pointer",backgroundColor:"dark"===v?"#3367D6":"#eee",color:"dark"===v?"#fff":"rgba(0, 0, 0, .54)",opacity:1},_=w?Object.assign({},k,f):i?Object.assign({},k,A):n?Object.assign({},k,{cursor:"pointer",opacity:.9}):k;return b.a.createElement(c,{onMouseEnter:function(){return o(!0)},onMouseLeave:function(){o(!1),a(!1)},onMouseDown:function(){return a(!0)},onMouseUp:function(){return a(!1)},onClick:I,style:_,type:u,disabled:w,className:s},[S&&b.a.createElement(g,{key:1,active:i}),b.a.createElement(p,{icon:S,key:2},y||d)])}y.defaultProps={type:"button",tag:"button",buttonText:"Sign in with Google",scope:"profile email",accessType:"online",prompt:"",cookiePolicy:"single_host_origin",fetchBasicProfile:!0,isSignedIn:!1,uxMode:"popup",disabledStyle:{opacity:.6},icon:!0,theme:"light",onRequest:function(){}};var S=y,j=function(e){var t=e.jsSrc,n=void 0===t?"https://apis.google.com/js/api.js":t,o=e.onFailure,r=e.onScriptLoadFailure,i=e.clientId,a=e.cookiePolicy,u=e.loginHint,l=e.hostedDomain,s=e.fetchBasicProfile,p=e.discoveryDocs,g=e.uxMode,y=e.redirectUri,b=e.scope,h=e.accessType,v=e.onLogoutSuccess,S=c(Object(m.useState)(!1),2),j=S[0],O=S[1],x=Object(m.useCallback)((function(){if(window.gapi){var e=window.gapi.auth2.getAuthInstance();null!=e&&e.then((function(){e.signOut().then((function(){e.disconnect(),v()}))}),(function(e){return o(e)}))}}),[v]);return Object(m.useEffect)((function(){var e=r||o;return f(document,"script","google-login",n,(function(){var t={client_id:i,cookie_policy:a,login_hint:u,hosted_domain:l,fetch_basic_profile:s,discoveryDocs:p,ux_mode:g,redirect_uri:y,scope:b,access_type:h};window.gapi.load("auth2",(function(){window.gapi.auth2.getAuthInstance()?O(!0):window.gapi.auth2.init(t).then((function(){return O(!0)}),(function(t){return e(t)}))}))}),(function(t){e(t)})),function(){d(document,"google-login")}}),[]),{signOut:x,loaded:j}};v.defaultProps={type:"button",tag:"button",buttonText:"Logout of Google",disabledStyle:{opacity:.6},icon:!0,theme:"light",jsSrc:"https://apis.google.com/js/api.js"};var O=v}],t.c=o,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:o})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(t.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var r in e)t.d(o,r,function(t){return e[t]}.bind(null,r));return o},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=4);function t(e){if(o[e])return o[e].exports;var r=o[e]={i:e,l:!1,exports:{}};return n[e].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n,o}));

/***/ })

}]);